/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'VIDEO NGẮN CỦA TÔI',
    see_more: 'XEM THÊM',
    no_shorts_found: 'Không tìm thấy video ngắn nào',
    shorts: 'Video ngắn',
    general_information: 'Thông tin chung',
    gamification: 'Trò chơi hóa',
    click_to_select_files: 'Nhấp để chọn tệp',
    selected_files: 'Tệp đã chọn',
    uploaded: 'Đã tải lên',
    failed: 'Thất bại',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Hệ thống sẽ tự động phân tích và chọn các tài liệu phù hợp nhất từ thư viện của tổ chức dựa trên yêu cầu nội dung.',
    select_from_library: ' Chọn từ thư viện',
    search_document: 'Tìm kiếm tài liệu...',
    selected: 'Đã chọn',
    loading_documents: 'Đang tải tài liệu...',
    review_generated_content: 'Xem lại nội dung đã tạo',
    confirm_and_replace_content: 'Xác nhận và thay thế nội dung',
    the_generate_content_will_replace:
      'Nội dung được tạo sẽ thay thế văn bản hiện có trên các trang đã chọn. Nếu bạn không muốn áp dụng các thay đổi này, bạn có thể quay lại bước trước.',
    pages_to_be_updated: 'Các trang cần cập nhật',
    generated_revisions: 'Các phiên bản đã tạo',
    lesson_preview: 'Xem trước bài học',
    create_new_folder: 'Tạo thư mục mới',
    rename_item: 'Đổi tên mục',
    enter_folder_name: 'Nhập tên thư mục:',
    enter_new_name: 'Nhập tên mới:',
    folder_name: 'Tên thư mục:',
    new_name: 'Tên mới',
    move_items: 'Di chuyển mục',
    copy_items: 'Sao chép mục',
    move_here: 'Di chuyển đến đây',
    copy_here: 'Sao chép đến đây',
    select_destination_library_and_folder: 'Chọn thư viện và thư mục đích:',
    items_selected: 'Các mục đã chọn',
    version: 'Phiên bản',
    modified_by: 'Chỉnh sửa bởi',
    size: 'Kích thước',
    restore: 'Khôi phục',
    are_you_sure_you_want_to_restore_this_version:
      'Bạn có chắc chắn muốn khôi phục phiên bản này không?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Điều này sẽ thay thế phiên bản hiện tại bằng phiên bản đã chọn.',
    restore_this_version: 'Khôi phục phiên bản này',
    restore_not_available: 'Không thể khôi phục',
    version_history: 'Lịch sử phiên bản:',
    by_making_items_public:
      'Khi công khai các mục, mọi người đều có thể thấy. Vui lòng xem xét các điều khoản trước khi tiếp tục.',
    the_selected_items_will_be_copied:
      'Các mục đã chọn sẽ được sao chép vào thư viện công khai của bạn và mọi người đều có thể nhìn thấy.',
    the_selected_items_will_be_copied_to_org:
      'Các mục đã chọn sẽ được sao chép vào thư viện tổ chức và tất cả thành viên tổ chức đều có thể nhìn thấy.',
    the_selected_items_will_be_copied_to_your_private:
      'Các mục đã chọn sẽ được sao chép vào thư viện riêng tư của bạn và chỉ bạn mới nhìn thấy.',
    loading_organization: 'Đang tải người dùng tổ chức...',
    click_download_to_view: 'Nhấp tải xuống để xem',
    archive_file: 'Tệp lưu trữ',
    no_preview_available: 'Không có bản xem trước',
    audit_report: 'Báo cáo kiểm toán',
    audit_type: 'Loại hành động',
    i_agree_to_the_terms_and_conditions:
      'Tôi đồng ý với các điều khoản và điều kiện.',
    this_file_is_indexed_for_ai: 'Tệp này được lập chỉ mục cho AI.',
    file_is_not_indexed_for_ai: 'Tệp chưa được lập chỉ mục cho AI.',
    no_users_found: 'Không tìm thấy người dùng',
    no_users_available: 'Không có người dùng',
    add_people: 'Thêm người',
    people: 'Người',
    access_type: 'Loại quyền truy cập',
    no_group_found: 'Không tìm thấy nhóm',
    add_group: 'Thêm nhóm',
    groups: 'Nhóm',
    users_top: 'Người dùng',
    confirm_delete: 'Xác nhận xóa',
    do_you_want_remove: 'Bạn có chắc muốn xóa',
    form_this_documents_permissions: 'khỏi quyền của tài liệu này?',
    no_users_found_in_this_group: 'Không tìm thấy người dùng trong nhóm này',
    add_selected_users: 'Thêm người dùng đã chọn',
    choose_users_from_the_list: 'Chọn người dùng từ danh sách',
    selected_users: 'Người dùng đã chọn',
    archived: 'Đã lưu trữ',
    request_approval: 'Yêu cầu phê duyệt',
    document_in_review: 'Tài liệu đang được xem xét',
    approve: 'Phê duyệt',
    reject: 'Từ chối',
    comment: 'Bình luận:',
    enter_your_commit: 'Nhập bình luận của bạn...',
    confirm_cancel: 'Xác nhận hủy',
    upload_3d_zip: 'Tải lên tệp 3D Zip',
    delete_items: 'Xóa mục',
    video_upload_request: 'Yêu cầu tải video lên',
    reject_video: 'Từ chối video',
    enter_rejection_reason: 'Nhập lý do từ chối...',
    please_provide_a_reason_for_reejection_this_video:
      'Vui lòng cung cấp lý do từ chối video này:',
    generate_trivia_with_ai: 'Tạo câu hỏi Trivia với AI',
    select_category: 'Chọn danh mục:',
    number_of_question: 'Số câu hỏi',
    generated_questions: 'Các câu hỏi đã tạo',
    this_will_clear_all_generate_question:
      'Điều này sẽ xóa tất cả các câu hỏi đã tạo. Tiếp tục?',
    sure_delete: 'Bạn có chắc muốn xóa không?',
    delete_this_question: 'Bạn có chắc muốn xóa câu hỏi này không?',
    loading_quiz: 'Đang tải Quiz...',
    creteing_file: 'Đang tạo tệp',
    opening_desktop_app: 'Đang mở ứng dụng máy tính',
    this_folder_is_empty: 'Thư mục này trống',
    select_a_competition: 'Chọn một cuộc thi...',
    activity_badges: 'Huy hiệu hoạt động',
    awarded_every_badges:
      'Trao sau mỗi 4, 8, 16, 32, 64, 128, 256, 512 lần đăng nhập',
    learning_badges: 'Huy hiệu học tập',
    awarded_every_courses:
      'Trao sau mỗi 1, 4, 8, 16, 32, 64, 128 khóa học hoàn thành',
    test_badges: 'Huy hiệu kiểm tra',
    awarded_every_passes_tests:
      'Trao sau mỗi 2, 4, 8, 16, 32, 64, 128, 256 bài kiểm tra vượt qua',
    assignment_badges: 'Huy hiệu bài tập',
    awarded_every_passed_assignments:
      'Trao sau mỗi 1, 2, 4, 8, 16, 32, 64, 128 bài tập vượt qua',
    perfectionism_badges: 'Huy hiệu sự hoàn hảo',
    awarded_every_assignments_with_scrore:
      'Trao sau mỗi 1, 2, 4, 8, 16, 32, 64, 128 bài kiểm tra/bài tập với điểm 90%+',
    communication_badges: 'Huy hiệu giao tiếp',
    awarded_every_topics_or_comments:
      'Trao sau mỗi 2, 4, 8, 16, 32, 64, 128, 256 chủ đề hoặc bình luận',
    certification_badges: 'Huy hiệu chứng nhận',
    awarded_every_certificates:
      'Trao sau mỗi 1, 2, 4, 8, 16, 32, 64, 128 chứng chỉ',
    level_name: 'Tên cấp độ',
    delete_competition: 'Xóa cuộc thi',
    this_week: 'Tuần này',
    this_year: 'Năm nay',
    make_organization: 'Tạo tổ chức',
    no_results_found: 'Không tìm thấy kết quả cho',
    no_items_available: 'Không có mục nào',
    help_video: 'Video hướng dẫn',
    select_a_video_from_the_list: 'Chọn một video từ danh sách để bắt đầu học'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Thả tệp và chọn nơi để tải lên.',
    duplicate_lessoon: 'Bài học đã có trong khóa học',
    skill_rule_title: 'Vui lòng nhập tiêu đề Hành trình Kỹ năng',
    imageCreatorTitle: 'Trình tạo hình ảnh',
    isTranslated: 'Đã dịch',
    translationCourseDesc:
      'Quá trình dịch khóa học có thể mất vài phút. Cảm ơn sự kiên nhẫn của bạn!',
    translateCourseTip:
      'Tạo một khóa học đã được dịch mà bạn có thể chỉnh sửa độc lập với bản gốc, bao gồm tất cả bài học và trang.',
    translateModalBtn: 'Dịch',
    translationSuccess: 'Khóa học "<0/>" đã được dịch thành công!',
    translatingCourse: 'Đang dịch khóa học...',
    translateModalTitle: 'Dịch khóa học',
    translateSelectLang: 'Chọn ngôn ngữ',
    fileDeleteconfirm:
      'Bạn có chắc chắn muốn xóa tệp này không? Hành động này không thể hoàn tác.',
    fileDeleteMessage: 'Tệp đã được xóa thành công.',
    fileDeleteFailedMessage: 'Xóa tệp thất bại!',
    fileDelete: 'Xóa tệp này.',
    certificate_save_btn: 'Thêm chứng chỉ vào ',
    maze_path_info: 'Không có đường đi nào có sẵn cho biểu đồ!',
    file_size_mb: 'Kích thước tệp phải nhỏ hơn 25 MB!',
    reports: {
      products: 'Sản phẩm',
      users: 'Người dùng',
      ph_username: 'Tìm người dùng theo tên đăng nhập',
      ph_id: 'Tìm người dùng theo số ID',
      ph_email: 'Tìm người dùng theo email'
    },
    select_upload_section_id: 'Phần tệp là bắt buộc',
    tags_all: 'Tất cả',
    delete_file_confirm: 'Bạn có chắc chắn muốn xóa tệp này không?',
    delete_file_title: 'Xóa tệp',
    tooltip_publish: 'Xuất bản khóa học theo tùy chọn đã chọn',
    tooltip_save: 'Lưu khóa học với các cập nhật hiện tại',
    tooltip_next: 'Chuyển đến thiết lập tiếp theo của khóa học',
    tooltip_finish: 'Hoàn tất và lưu các cập nhật hiện tại',
    stories_modal: {
      title_upload: 'Tải lên Câu chuyện',
      title_update: 'Cập nhật Câu chuyện',
      title_audio: 'Tệp âm thanh câu chuyện',
      btn_upload: 'Tải lên',
      btn_update: 'Cập nhật',
      btn_close: 'Đóng',
      btn_cancel: 'Hủy',
      lbl_cover: 'Ảnh bìa câu chuyện',
      rule_cover: 'Vui lòng tải ảnh bìa âm thanh!',
      lbl_title: 'Tiêu đề âm thanh câu chuyện',
      rule_title: 'Vui lòng nhập tiêu đề âm thanh!',
      lbl_description: 'Mô tả âm thanh câu chuyện',
      rule_description: 'Vui lòng nhập mô tả câu chuyện!',
      lbl_file: 'Tải tệp âm thanh câu chuyện',
      rule_file: 'Vui lòng tải tệp âm thanh!',
      rule_file_type: 'Vui lòng tải đúng định dạng tệp âm thanh!',
      lbl_select_file: 'Chọn tệp âm thanh câu chuyện',
      msg_valid_file: 'Vui lòng chọn tệp âm thanh hợp lệ!',
      msg_success: 'Tệp âm thanh đã được tải lên thành công',
      msg_failed: 'Gán dữ liệu phương tiện thất bại!',
      msg_error: 'Lỗi khi tải tệp!'
    },
    audio_modal: {
      title_upload: 'Tải lên',
      title_update: 'Cập nhật',
      title_audio: 'Tệp âm thanh',
      btn_upload: 'Tải lên',
      btn_update: 'Cập nhật',
      btn_close: 'Đóng',
      btn_cancel: 'Hủy',
      lbl_cover: 'Ảnh bìa âm thanh',
      rule_cover: 'Vui lòng tải ảnh bìa!',
      lbl_title: 'Tiêu đề âm thanh',
      rule_title: 'Vui lòng nhập tiêu đề âm thanh!',
      lbl_description: 'Mô tả âm thanh',
      rule_description: 'Vui lòng nhập mô tả!',
      lbl_file: 'Tải tệp âm thanh',
      rule_file: 'Vui lòng tải một tệp âm thanh!',
      rule_file_type: 'Vui lòng tải đúng định dạng âm thanh!',
      lbl_select_file: 'Chọn tệp âm thanh',
      msg_valid_file: 'Vui lòng chọn một tệp âm thanh hợp lệ!',
      msg_success: 'Tệp âm thanh đã được tải lên thành công',
      msg_failed: 'Gán dữ liệu phương tiện thất bại!',
      msg_error: 'Lỗi khi tải tệp!'
    },
    info_episode: 'Ảnh bìa cho tập podcast.',
    btn_delete_episode: 'Xóa tập podcast này.',
    btn_edit_marketplace: 'Chỉnh sửa chi tiết Marketplace.',
    btn_save_marketplace: 'Lưu các thay đổi hiện tại.',
    btn_ai_podcast: 'Tạo tập podcast với AI.',
    btn_upload_podcast: 'Tải lên tập podcast của riêng bạn.',
    attach_file: 'Tải tệp lên để chia sẻ thêm nội dung với khán giả',
    fileDownload: 'Tải tệp này.',
    singleEpishode: 'Tập',
    podcast_music: 'podcast, nhạc & câu chuyện',
    publishHeader: 'Xuất bản Podcast, Nhạc & Câu chuyện',
    editHeader: 'Chỉnh sửa Podcast, Nhạc & Câu chuyện',
    createHeader: 'Tạo Podcast, Nhạc & Câu chuyện',
    marketplaceHeader: 'Chi tiết Marketplace cho Podcast, Nhạc & Câu chuyện',
    message_marketplace: 'Vui lòng hoàn thành biểu mẫu marketplace!',
    create_podcast_live: 'Podcast và Nhạc Trực tiếp',
    create_podcast_custom: 'Podcast và Nhạc Tùy chỉnh',
    create_podcast_stories: 'Câu chuyện',
    ai_Assisted_podcast_reation: 'Tạo Podcast & Nhạc với AI',
    publishTitle: 'Xuất bản podcast, nhạc & câu chuyện để công khai.',
    customButton: 'Tạo Tùy chỉnh',
    customTitle: 'Lưu thay đổi đã thực hiện với podcast.',
    updateButton: 'Cập nhật',
    createButton: 'Tạo',
    createNewButton: 'Tạo Mới',
    updateTitle: 'Cập nhật chi tiết podcast, nhạc & câu chuyện hiện tại.',
    createTitle: 'Tạo mới podcast, nhạc & câu chuyện',
    createNewTitle:
      'Podcast, nhạc & câu chuyện mới sẽ được tạo dựa trên bản hiện tại với thông tin mới.',
    podcastTitle: 'Danh sách tập',
    podcastStoryTitle: 'Danh sách tập câu chuyện',
    podcastToolTipTitle: 'Danh sách tập podcast',
    uploadAudio: 'Tải lên',
    aiAudio: 'Âm thanh AI',
    emptyPodcast: 'Chưa có bản ghi podcast, nhạc hoặc câu chuyện nào.',
    emptyStoriesPodcast: 'Chưa có câu chuyện nào được thêm.',
    emptyCreatePodcast: 'Vui lòng tạo podcast để thêm âm thanh.',
    playPodcast: 'Phát podcast, nhạc & câu chuyện đã chọn.',
    pausePodcast: 'Tạm dừng podcast, nhạc & câu chuyện đã chọn.',
    selectPodcast: 'Chọn podcast, nhạc & câu chuyện này.',
    downloadPodcast: 'Tải âm thanh này.',
    uploadAudioFile: 'Tải lên âm thanh mới và thay thế âm thanh hiện tại.',
    deleteConfirm: 'Bạn có chắc muốn xóa âm thanh này không?',
    roomName: 'Tên Podcast',
    addGuestTitle: 'THÊM DIỄN GIẢ KHÁCH MỜI',
    showTime: 'Thời gian chiếu',
    startTime: 'Thời gian bắt đầu',
    endTime: 'Thời gian kết thúc',
    erorMsgImg: 'Vui lòng chọn ảnh hợp lệ.',
    failedMsgImg: 'Tải ảnh thất bại. Vui lòng thử lại!',
    failedMsgUpload: 'Tải ảnh bìa thất bại!',
    btnCoverUpload: 'Tải ảnh bìa',
    is_private: 'Riêng tư',
    to_attach: 'Đính kèm Tệp',
    file_attached: 'Tệp đã đính kèm',
    main_event: 'Sự kiện chính',
    event: 'Sự kiện',
    upload_pdf: 'Tải PDF',
    portrait: 'Dọc',
    landscape: 'Ngang',
    import_from_library: 'Nhập văn bản từ Thư viện phương tiện',
    question_answer_ai: 'Hỏi/Đáp AI',
    take_maze: 'BẮT ĐẦU MetaMaze',
    training: 'Đào tạo',
    select_transcribe_locale: 'Chọn ngôn ngữ để phiên âm',
    transcribe_limit: 'Vui lòng nhập số phút phiên âm',
    not_complete: 'Thông tin Marketplace chưa đầy đủ',
    complete: 'Thông tin Marketplace đã hoàn thành',
    not_admin: 'Cần quyền quản trị để xuất bản lên Marketplace',
    no_course: 'Vui lòng nhập tiêu đề và chọn ảnh để bật Marketplace',
    scorm_not_complete: 'Vui lòng nhập tiêu đề và chọn ảnh để tải tệp SCORM',
    not_found_maze: 'Không tìm thấy MetaMaze',
    email_require: 'Yêu cầu địa chỉ email',
    poll_required: 'Yêu cầu dữ liệu khảo sát',
    alert: 'Thông báo!',
    warning: 'Cảnh báo!',
    ok: 'Đồng ý',
    cancel: 'Hủy',
    done: 'Hoàn thành',
    insert: 'Chèn',
    private: 'Riêng tư',
    public: 'Công khai',
    no_connection: 'Mất kết nối Internet',
    switch: 'Chuyển đổi',
    share_screen: 'Chia sẻ màn hình',
    stop_share_screen: 'Dừng chia sẻ màn hình',
    share_screen_with_camera: 'Chia sẻ màn hình kèm camera',
    stop_share_screen_with_camera: 'Dừng chia sẻ màn hình kèm camera',
    camera_on: 'Bật camera',
    camera_off: 'Tắt camera',
    mic_on: 'Bật mic',
    mic_off: 'Tắt mic',
    fullscreen: 'Toàn màn hình',
    live_now: 'Đang phát trực tiếp',
    schedule_on: 'Lên lịch vào',
    organisations: 'Tổ chức',
    org_groups: 'Nhóm tổ chức',
    specific_user: 'Người dùng cụ thể',
    gif: 'GIF',
    unavailable: 'Không khả dụng',
    yes: 'Có',
    no: 'Không',
    event_duration_message: 'Tối đa 300 phút (5 giờ)',
    send_email: 'Gửi thông báo email',
    admin_only: 'Chỉ quản trị viên',
    join: 'Tham gia',
    leave: 'Rời khỏi',
    share: 'Chia sẻ',
    share_text:
      'Vui lòng nhập địa chỉ email của người bạn muốn chia sẻ tệp này.',
    share_text_title: 'Chia sẻ PDF',
    share_text_title_txt: 'Chia sẻ văn bản',
    select_users: 'Chọn người dùng',
    delete: 'Xóa',
    attachment_event: 'Tệp đính kèm cho sự kiện:',
    transcribe_limit: 'Phút phiên âm',
    monthly_transcribe: 'Giới hạn phiên âm hàng tháng:',
    enable_ai: 'Bật AI:',
    enable_maze: 'Bật MetaMaze:',
    media_service: 'Dịch vụ truyền thông',
    allow_others: 'Cho phép người khác chỉnh sửa',
    join_breakout_room: 'Tham gia phòng thảo luận',
    bio: 'Tiểu sử',
    linkedin: 'LinkedIn',
    select_org_report: 'Tìm và chọn tổ chức để tạo báo cáo.',
    org_image_not_found: 'Không tìm thấy hình ảnh',
    insert_text: 'Chèn văn bản',
    insert_question_answer: 'Hỏi/Đáp AI',
    modal_title2: 'Thư viện văn bản',
    my_text_library: 'Thư viện văn bản của tôi',
    ai: 'AI',
    public_text_library: 'Thư viện văn bản công khai',
    organization_text_library: 'Thư viện văn bản tổ chức',
    no_transcribed_text: 'Không tìm thấy văn bản phiên âm',
    public_text_not_found: 'Không tìm thấy văn bản phiên âm công khai',
    org_text_not_found: 'Không tìm thấy văn bản phiên âm tổ chức',
    org_video_not_found: 'Không tìm thấy video',
    canva: 'Thực hiện bằng Canva',
    canva_open: 'Nhấn vào đây để mở trình chỉnh sửa Canva.',
    pdf: 'PDF',
    txt: 'VĂN BẢN',
    human: 'Cao cấp',
    shared_file: 'Tệp của bạn đã được chia sẻ thành công.',
    error_shared_file: 'Đã xảy ra sự cố khi chia sẻ tệp. Vui lòng thử lại.',
    publish: 'Xuất bản',
    maze_scenes: 'Cảnh MetaMaze',
    pexel_images: 'Hình ảnh Pexel',
    group: 'Nhóm',
    group_name: 'Tên nhóm',
    select_group: 'Chọn nhóm',
    search_maze: 'Tìm kiếm MetaMaze',
    hosts: 'Người dẫn',
    avg_score: 'Điểm trung bình (%)',
    maze_report: 'Báo cáo Maze',
    maze_view: 'Xem Maze',
    title_maze: 'MetaMaze',
    author: 'Tác giả',
    match: 'Đường dẫn khớp',
    preview_mazeTitle: 'Tiêu đề: ',
    other: 'Khác',
    total: 'TỔNG',
    report_course: 'KHÓA HỌC',
    report_courses: 'CÁC KHÓA HỌC',
    report_event: 'SỰ KIỆN',
    report_events: 'CÁC SỰ KIỆN',
    report_maze: 'MAZE',
    report_personalize_learning: 'HỌC TẬP CÁ NHÂN HÓA',
    report_live_assessment: 'ĐÁNH GIÁ TRỰC TIẾP',
    report_live_assessments: 'CÁC ĐÁNH GIÁ TRỰC TIẾP',
    report_skill_journey: 'HÀNH TRÌNH KỸ NĂNG',
    skill_journey: 'Hành trình kỹ năng',
    skill_journeys: 'Các hành trình kỹ năng',
    date: 'NGÀY: ',
    search_people: 'Tìm kiếm người dùng',
    passed: 'ĐẠT',
    failed: 'KHÔNG ĐẠT',
    item: 'MỤC',
    type: 'LOẠI',
    minimum_pass_score: 'ĐIỂM ĐẬU TỐI THIỂU',
    resources_count: 'SỐ LƯỢNG TÀI NGUYÊN',
    back: 'QUAY LẠI',
    resources: 'TÀI NGUYÊN',
    time_spent: 'THỜI GIAN ĐÃ DÙNG (PHÚT)',
    detail: 'CHI TIẾT',
    watched_time_mins: 'THỜI GIAN XEM (PHÚT)',
    personalize_learning: 'Học tập cá nhân hóa',
    result: 'Kết quả',
    assessment_title: 'Tiêu đề',
    marketPlace_graph: 'Biểu đồ Marketplace',
    attachments: 'Tệp đính kèm bổ sung',
    new_scorm_course: 'Tải lên khóa học SCORM mới',
    upload_scorm_course: 'Tải lên khóa học SCORM',
    new_maze: 'Tạo MetaMaze mới',
    new_skill_journey: 'Tạo Hành Trình Kỹ Năng',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Hành Trình Kỹ Năng',
    new_discussion_room: 'Tạo Podcast mới',
    title: 'Hôm nay bạn muốn làm gì?',
    build_course: 'Xây dựng khóa học của tôi',
    live_broadcast: 'Phát sóng trực tiếp',
    invite_users: 'Mời người dùng vào tổ chức của tôi',
    build_voice_over: 'Tạo giọng đọc cho tôi',
    view_reports: 'Xem báo cáo',
    upload_media: 'Tải lên phương tiện hoặc tác phẩm và chia sẻ',
    main_menu: 'Menu chính',
    get_started: 'BẮT ĐẦU',
    search_group: 'Tìm nhóm tổ chức',
    ai_course: 'Khóa học AI',
    search_user: 'Tìm tên công ty',
    no_maze: 'Hiện chưa có MetaMaze nào.',
    conference_event_title: 'Sự kiện hội nghị',
    conference_event_subTitle: 'Sự kiện hội nghị đã kết thúc',
    conference_event: 'Hiện chưa có sự kiện hội nghị nào.',
    no_skill: 'Hiện chưa có hành trình kỹ năng nào.',
    no_podcast: 'Hiện chưa có podcast nào.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Đánh giá trực tiếp trước đó',
    no_live_assessment: 'Hiện chưa có đánh giá trực tiếp nào.',
    enrolled_courses: 'Khóa học đã đăng ký',
    my_video_channel: 'Kênh video của tôi',
    enrolled_liveEvents: 'Sự kiện trực tiếp đã đăng ký',
    sharebot: 'Sharebot',
    selected_language: 'Ngôn ngữ đã chọn',
    shareSphere_game: 'Trò chơi ShareSphere',
    maze: 'MetaMaze',
    skill: 'Hành Trình Kỹ Năng',
    channel: 'Kênh',
    order: 'Thứ tự',
    is_record: 'Ghi âm',
    no_maze_found: 'Không tìm thấy MetaMaze.',
    maze_self_limit_reached: 'Đã đạt giới hạn tự đánh giá MetaMaze.',
    metamaze_two_times: 'Bạn đã làm MetaMaze này 2 lần.',
    metamaze_two_times_no_result:
      'Bạn đã làm MetaMaze này 2 lần. Kết quả sẽ không được lưu sau lần thứ ba.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Điểm tối thiểu để qua',
    organization: 'Vui lòng chọn một tổ chức',
    pass_score_mark: 'Vui lòng nhập điểm từ 1 đến 100',
    maze_cloning_success: 'MetaMaze "<0/>" đã được sao chép thành công!',
    create_certificate: 'Tạo chứng chỉ',
    create_badge: 'Tạo huy hiệu',
    certificate_added: 'Đã thêm chứng chỉ.',
    badge_added: 'Đã thêm huy hiệu.',
    certificate_warning:
      'Bạn không thể chỉnh sửa chứng chỉ/huy hiệu sau khi đã xuất bản!',
    created_course_plan:
      'Chỉnh sửa và xuất bản khóa học bạn đã tạo và lên lịch sự kiện trực tiếp',
    market_place_space: 'Chợ nội dung',
    select_course_language: 'Chọn ngôn ngữ (Không bắt buộc)',
    select_language: 'Chọn ngôn ngữ',
    file_upload: 'Tải lên tập tin',
    text: 'Viết nội dung tại đây…',
    attempts_count: 'Số lần người dùng có thể làm lại',
    no_of_people_placeholder: 'Số người',
    back_to_maze: 'Quay lại kịch bản MetaMaze',
    edit_maze: 'Chỉnh sửa Maze',
    wait: 'Vui lòng chờ...',
    retry: 'Thử lại',
    publish_scorm_course: 'Xuất bản khóa học SCORM của bạn',
    publish_maze: 'Xuất bản MetaMaze của bạn',
    import: 'Nhập các thành phần',
    answer_correct: 'Vui lòng chọn đáp án đúng',
    author_name: 'Vui lòng nhập tên tác giả',
    select_category: 'Vui lòng chọn danh mục',
    course_outline: 'Vui lòng nhập đề cương khóa học',
    course_obj: 'Vui lòng nhập mục tiêu khóa học',
    course_description: 'Vui lòng nhập mô tả khóa học',
    maze_outline: 'Vui lòng nhập đề cương mê cung',
    maze_obj: 'Vui lòng nhập mục tiêu mê cung',
    maze_description: 'Vui lòng nhập mô tả mê cung',
    lessons: 'Vui lòng nhập số lượng bài học',
    user_email_require: 'Email người dùng là bắt buộc',
    team_size: 'Vui lòng nhập số lượng thành viên nhóm',
    enter_price: 'Vui lòng nhập giá (từ 5 trở lên)',
    input_title_maze: 'Vui lòng nhập tiêu đề mê cung',
    trainer_bio: 'Vui lòng nhập tiểu sử giảng viên',
    trainer_linkedin: 'Vui lòng nhập liên kết LinkedIn của giảng viên',
    error_video: 'Vui lòng nhập số lượng video',
    input_video_link: 'Vui lòng nhập liên kết video',
    number_of_video: 'Số lượng video',
    number_of_lessions: 'Số lượng bài học',
    no_of_people_in_conference: 'Có bao nhiêu người trong hội nghị?',
    transcribe_settings: 'Cài đặt phiên âm',
    transcribe: 'Phiên âm',
    cloning_maze: 'Đang sao chép MetaMaze...',
    id_number: 'Số CMND/CCCD',
    timezone: 'Múi giờ',
    edit_maze: 'Chỉnh sửa',
    delete_maze: 'Xóa',
    view_maze: 'Xem',
    create_metamaze: 'Tạo MetaMaze',
    metamaze_scenario: 'Kịch bản MetaMaze',
    publish_metamaze: 'Cài đặt xuất bản',
    search_result: 'Kết quả tìm kiếm:',
    search_for: 'Tìm kiếm',
    search_no_result: '- Không có kết quả phù hợp!',
    channel_no_available: 'Không có kênh nào khả dụng!',
    this_card: 'Đây là một thẻ',
    course_no_available: 'Không có khóa học nào!',
    exit_fullscreen: 'Thoát toàn màn hình',
    bg_image: 'Hình nền',
    introduction: 'Giới thiệu',
    summary: 'Tóm tắt',
    generate_introduction: 'Tạo phần giới thiệu',
    generate_summary: 'Tạo tóm tắt',
    bullet_points: 'Ý chính',
    title_simulation: 'Vui lòng nhập tiêu đề mô phỏng',
    view_generated_images: 'Xem hình ảnh đã tạo',
    image_transparency: 'Độ trong suốt hình ảnh',
    template_bg_color: 'Màu nền mẫu',
    select_template_layout: 'Chọn bố cục mẫu',
    reload_template: '(Tải lại mẫu)',
    are_you_sure_want_close: 'Bạn có chắc muốn đóng không?',
    all_your_changes_will_be_lost: 'Mọi thay đổi của bạn sẽ bị mất.',
    please_checked_before_generated_video:
      'Vui lòng kiểm tra tất cả điều kiện trước khi tạo video.',
    voice_must_be_selected: 'Phải chọn giọng nói',
    avatar_must_be_selected: 'Phải chọn ảnh đại diện',
    maximum_five_slides_try_again:
      'Đã xảy ra lỗi khi trích xuất hình ảnh từ tệp. Vui lòng đảm bảo tệp có tối đa 5 trang trình chiếu và mỗi trang đều có ghi chú. Thử lại!',
    back_to_upload: 'Quay lại tải lên',
    uploading_file_to_server: 'Đang tải tệp lên máy chủ',
    extracting_images_from_your_file: 'Đang trích xuất hình ảnh từ tệp của bạn',
    upload_your_ppt_or_drag: 'Tải lên tệp trình chiếu (.PPTX) hoặc kéo vào đây',
    maximum_five_slides_error:
      'Vui lòng đảm bảo tệp PowerPoint có tối đa 5 trang trình chiếu và mỗi trang đều có ghi chú, nếu không sẽ xảy ra lỗi.',
    number_of_questions_generated: 'Số lượng câu hỏi cần tạo',
    quiz_page_this_cannot_be_done:
      'Bạn có chắc muốn thêm bài kiểm tra vào trang này? Thao tác này không thể hoàn tác.',
    confirm_selection: 'Xác nhận lựa chọn',
    select_quiz_page: 'Chọn trang kiểm tra',
    lesson_do_you_want_add_this_quiz:
      'Bạn muốn thêm bài kiểm tra này vào phần nào của bài học?',
    beginning_of_lesson: 'Phần đầu bài học',
    end_of_lesson: 'Phần cuối bài học',
    currently_active_page: 'Trang đang hoạt động',
    finish: 'Hoàn tất',
    upload_selection_file: 'Tải tệp đoạn lên',
    general_quiz: 'Bài kiểm tra tổng quát',
    manage_sequence: 'Quản lý thứ tự',
    save_sequence: 'Lưu thứ tự',
    new: 'Mới',
    in_progress: 'Đang tiến hành',
    recommended_course: 'Khóa học được đề xuất',
    up_coming: 'Sắp diễn ra',
    past_live: 'Buổi phát sóng đã qua',
    input_your_channel_name: 'Vui lòng nhập tên kênh của bạn!',
    organization_place: 'Chợ tổ chức',
    marketplace_report: 'Báo cáo chợ',
    story_writing: 'Viết truyện',
    Ai_quiz: 'Kiểm tra AI',
    generate_quiz: 'Tạo bài kiểm tra',
    create_story: 'Tạo câu chuyện',
    change_layout_page: 'Bạn sắp thay đổi bố cục của trang này.',
    change_layout_message:
      'Lưu ý: Chỉ văn bản, hình ảnh, nền và logo sẽ được giữ lại. Mọi thành phần khác sẽ bị xóa khỏi trang.',
    reviews: 'Đánh giá',
    tab_attachments: 'Tệp đính kèm',
    zoom_in: 'Phóng to',
    zoom_out: 'Thu nhỏ',
    zoom_reset: 'Đặt lại thu phóng',
    no_attachment: 'Không có tệp đính kèm.',
    select_upload_simulation: 'Vui lòng chọn hoặc tải lên mô phỏng.',
    quiz_updated_successfully: 'Bài kiểm tra đã được cập nhật thành công!',
    quizes: 'Bài kiểm tra',
    trivia: 'Đố vui',
    closing: 'Đang đóng...',
    products: 'Sản phẩm',
    ask_questions: 'Đặt câu hỏi tại đây...',
    course_information: 'Thông tin khóa học',
    course_assistance: 'Hỗ trợ người tạo khóa học',
    go_back: 'Quay lại',
    ai_generate_content_progress: 'Đang tạo nội dung bằng AI',
    view_generate_content: 'Xem nội dung đã tạo',
    generate_error: 'Lỗi khi tạo nội dung!',
    confirm_creating_course:
      'Bạn có muốn xác nhận tạo khóa học bằng nội dung này không?',
    generate_content_automatically:
      'Thao tác này sẽ thêm toàn bộ nội dung được tạo làm bài học và trang vào khóa học của bạn một cách tự động.',
    quiz_created_successfully: 'Tạo câu hỏi trắc nghiệm thành công!',
    create_quiz: 'Tạo câu hỏi trắc nghiệm',
    quiz_setting: 'Cài đặt bài trắc nghiệm',
    please_fill_quiz_setting:
      '* Vui lòng điền tất cả các trường trong Cài đặt Trắc nghiệm',
    question_list: 'Danh sách câu hỏi',
    add_quiz_to_page: 'Thêm câu hỏi trắc nghiệm vào trang',
    form_create_question: 'Biểu mẫu tạo câu hỏi',
    user_information_updated: 'Thông tin người dùng đã được cập nhật!',
    your_stripe_activete_to_continue:
      'Tài khoản Stripe của bạn chưa được kích hoạt. Vui lòng kết nối hoặc kích hoạt để tiếp tục.',
    connect_tripe: 'Kết nối Stripe',
    certificate_sent_sucessfully:
      'Chứng chỉ đã được gửi đến email của bạn thành công.',
    error_try_again: 'Lỗi. Vui lòng thử lại!',
    error_delete_channel: 'Lỗi khi xóa kênh.',
    error_update_sub: 'Lỗi khi cập nhật gói đăng ký.',
    end_time_cannot_start:
      'Thời gian kết thúc không thể trước thời gian bắt đầu.',
    start_date_time_interval: 'Yêu cầu nhập ngày và giờ bắt đầu!',
    podcast_updated_successful: 'Podcast đã được cập nhật thành công.',
    podcast_created_successful: 'Podcast đã được tạo thành công.',
    podcast_published_successful: 'Podcast đã được xuất bản thành công.',
    podcast_cover_updated: 'Ảnh bìa podcast đã được cập nhật.',
    new_podcast_details:
      'Podcast mới sẽ được tạo với thông tin đầu vào hiện tại.',
    current_update_podcast:
      'Cập nhật podcast hiện tại, nhạc và thông tin câu chuyện.',
    create_new_podcast: 'Tạo podcast mới',
    publish_podcast_public_view: 'Xuất bản podcast để công khai.',
    only_allowed_twenty_five_email: 'Chỉ cho phép tối đa 25 email',
    only_allowed_five_email: 'Chỉ cho phép tối đa 5 email.',
    cover_is_required: 'Bắt buộc phải có ảnh bìa.',
    topic_is_required: 'Bắt buộc phải có chủ đề.',
    delete_schedule: 'Xóa lịch trình',
    make_as_coaching: 'Đánh dấu là buổi huấn luyện',
    manage_category: 'Quản lý danh mục',
    threshold: 'Ngưỡng',
    threshold_popup:
      'Giá trị ngưỡng tính theo phần trăm (%), là mức mà sau đó hệ thống sẽ kích hoạt đề xuất cho danh mục tương ứng.',
    list_of_catagory: 'Danh sách danh mục',
    category_name: 'Tên danh mục',
    category_threshold: 'Ngưỡng danh mục',
    play_game: 'Chơi trò chơi',
    switching_organization: 'Đang chuyển tổ chức...',
    coaching_session: 'Buổi huấn luyện',
    required_channel_id: 'Yêu cầu có ID kênh!',
    error_occured_try_again: 'Đã xảy ra lỗi. Vui lòng thử lại!',
    please_complete_marketplace_form:
      'Vui lòng hoàn tất biểu mẫu chợ ứng dụng!',
    upload_file_corrupt: 'Tệp được tải lên bị hỏng.',
    course_not_published: 'Khóa học chưa được xuất bản!',
    error_request: 'Lỗi yêu cầu. Vui lòng thử lại!',
    skill_request: 'Vui lòng điền đầy đủ các trường bắt buộc!',
    error_occured: 'Đã xảy ra lỗi. Vui lòng thử lại!',
    show_time: 'Hiển thị thời gian',
    start_time: 'Thời gian bắt đầu',
    end_time: 'Thời gian kết thúc',
    room_name: 'Tên Podcast',
    add_guest_speaker: 'Thêm diễn giả khách mời',
    cover_picture: 'Ảnh bìa',
    guest_speaker: 'Diễn giả khách mời',
    see_more: 'Xem thêm',
    see_less: 'Thu gọn',
    background: 'Nền',
    icon: 'Biểu tượng',
    icon_size: 'Kích thước biểu tượng',
    icon_color: 'Màu biểu tượng',
    only_text: 'Chỉ văn bản',
    change_bg: 'Thay đổi màu nền',
    bg_color: 'Màu nền',
    font_size: 'Cỡ chữ',
    normal: 'Bình thường',
    change_color: 'Thay đổi màu chữ',
    slant_text: 'Văn bản nghiêng',
    text_radius: 'Bo góc văn bản',
    vertical_align: 'Căn chỉnh dọc',
    horizontal_align: 'Căn chỉnh ngang',
    change_icon_color: 'Thay đổi màu biểu tượng',
    upload_icon: 'Tải lên biểu tượng',
    upload_signature: 'Tải lên chữ ký',
    add_another_sign: 'Thêm chữ ký khác',
    name_badges: 'Tên huy hiệu',
    should_less_150: 'nên ít hơn hoặc bằng 150 ký tự',
    your_badge: 'Huy hiệu của bạn',
    do_you_want_delete_badge: 'Bạn có chắc muốn xóa huy hiệu này không?',
    do_you_want_delete_cert: 'Bạn có chắc muốn xóa chứng chỉ này không?',
    upload_logo: 'Tải lên logo',
    name_of_cert: 'Tên chứng chỉ',
    upload_cert: 'Cập nhật chứng chỉ',
    your_cert: 'Chứng chỉ của bạn',
    translate_to: 'Dịch sang',
    select_file_attach: 'Chọn tệp để đính kèm',
    certificate: 'Chứng chỉ',
    badge: 'Huy hiệu',
    publish_options: 'Tùy chọn xuất bản',
    publish_skills_journey: 'Xuất bản hành trình kỹ năng',
    videos: 'Video',
    generate_ai_video:
      'Quá trình tạo video bằng AI có thể mất một chút thời gian. Bạn sẽ nhận được thông báo qua email khi hoàn tất.',
    trainer_information: 'Thông tin huấn luyện viên',
    promotional_video_link: 'Liên kết video quảng bá',
    please_select: 'Vui lòng chọn',
    image_name: 'Tên hình ảnh:',
    image_size: 'Kích thước hình ảnh:',
    charecters_fifteen_less: '15 ký tự hoặc ít hơn',
    leadership: 'Lãnh đạo',
    text_arc: 'Vòng cung văn bản',
    vertical: 'Dọc',
    horizontal: 'Ngang',
    badge_history: 'Lịch sử huy hiệu',
    templates: 'Mẫu',
    sign: 'Chữ ký',
    logo: 'Logo',
    certificate_history: 'Lịch sử chứng chỉ',
    please_wait: 'Vui lòng chờ...',
    information: 'Thông tin',
    support_five_thousand_live_event:
      'Hỗ trợ tối đa 5000 người tham gia sự kiện',
    support_ten_live_event: 'Hỗ trợ tối đa 10 người tham gia video trực tiếp',
    we_will_back_participant:
      'Chúng tôi sẽ quay lại với sự kiện có số lượng người tham gia lớn hơn.',
    course_objectives: 'Mục tiêu khóa học',
    course_outlines: 'Đề cương khóa học',
    price_dollor: 'giá (USD)',
    not_completed: 'Chưa hoàn thành',
    enable_marketplace: 'Bật Chợ Ứng Dụng',
    enable_course_ai: 'Bật Tạo Khóa Học bằng AI',
    enable_report_to_admin: 'Bật Hiển Thị Báo Cáo cho Quản Trị Viên',
    enable_white_label: 'Bật White Label',
    enable_eleven_labs_for_maze_play: 'Bật Elevenlabs cho Maze Play',
    enable_eleven_labs_for_maze_play_cloned:
      'Bật Elevenlabs với giọng nói sao chép',
    simulation_quiz: 'Bài kiểm tra mô phỏng',
    bg_color_setting: 'Cài đặt màu nền',
    color_preview: 'Xem trước màu',
    choose_new_color: 'Chọn màu mới',
    remove_color: 'Xóa màu',
    apply_color: 'Áp dụng màu',
    elemeent_in_a_sceenario_page:
      'Bạn không thể thêm phần tử khác vào trang tình huống. Vui lòng thử trang khác hoặc xóa tình huống trước.',
    no_data_found: 'Không tìm thấy dữ liệu.',
    references: 'Tài liệu tham khảo',
    open_file: 'Mở tệp',
    showing_result: 'Hiển thị kết quả:',
    fiften_day_free_trail: 'Dùng thử miễn phí 15 ngày',
    your_browser_does_not_support:
      'Trình duyệt của bạn không hỗ trợ phần tử âm thanh.',
    podcast_desc: 'Mô tả Podcast',
    input_podcast_desc: 'Vui lòng nhập mô tả Podcast',
    podcast_obj: 'Mục tiêu Podcast',
    input_podcast_obj: 'Vui lòng nhập mục tiêu Podcast',
    podcast_outline: 'Đề cương Podcast',
    input_podcast_outline: 'Vui lòng nhập đề cương Podcast',
    add_file: 'Thêm tập tin',
    generate_podcast_audio: 'Tạo âm thanh Podcast',
    generate_uploaded_file_input_parameter:
      'Tạo nội dung dựa trên các tập tin được tải lên và các tham số đầu vào đã chỉ định.',
    go_backe_generation_state: 'Quay lại trạng thái tạo nội dung.',
    create_ai_powered_podcast:
      'Tạo tập Podcast được hỗ trợ bởi AI với âm thanh được tạo tự động.',
    generate_voice_for_all_podcast:
      'Vui lòng tạo giọng nói cho tất cả các tập Podcast',
    create_podcast_episode: 'Tạo tập Podcast',
    voice_name: 'Tên giọng nói',
    input_custom_name: 'Vui lòng nhập tên tuỳ chỉnh!',
    enter_custom_name: 'Nhập tên giọng nói tuỳ chỉnh',
    upload_complete: 'Tải lên hoàn tất',
    uploading_in_progress: 'Đang tải lên...',
    podcast_stream_content: 'Nội dung luồng Podcast',
    upload_podcast_cover: 'Vui lòng tải lên ảnh bìa Podcast!',
    enter_podcast_name: 'Vui lòng nhập tên Podcast!',
    podcast_topic: 'Chủ đề Podcast',
    enter_podcast_topic: 'Vui lòng nhập chủ đề Podcast!',
    enter_podcast_desc: 'Vui lòng nhập mô tả Podcast!',
    number_of_speaker: 'Số lượng người nói',
    select_the_number_of_speaker: 'Vui lòng chọn số lượng người nói!',
    number_of_episode: 'Số tập',
    input_number_of_episode: 'Vui lòng nhập số tập!',
    podcast_length: 'Độ dài Podcast',
    select_the_podcast_length: 'Vui lòng chọn độ dài Podcast!',
    short_podcast: 'Ngắn (5-10 phút)',
    medium_podcast: 'Trung bình (15-18 phút)',
    long_podcast: 'Dài (hơn 18 phút)',
    name_of_host: 'Tên người dẫn chương trình',
    enter_host_name: 'Vui lòng nhập tên người dẫn chương trình!',
    guest_name: 'Tên khách mời',
    enter_guest_name: 'Vui lòng nhập tên khách mời!',
    choose_speaker_tone: 'Chọn giọng điệu người nói',
    enter_speaker_tone: 'Vui lòng chọn giọng điệu Podcast!',
    informal: 'Không trang trọng',
    formal: 'Trang trọng',
    serious: 'Nghiêm túc',
    light_humor: 'Hài hước nhẹ',
    casual: 'Thân mật',
    select_content_source: 'Chọn nguồn nội dung',
    from_internet: 'Từ Internet',
    upload_pdf_internet: 'Tải lên tệp PDF hoặc tài liệu nội bộ',
    note: 'Lưu ý:',
    podcast_content_will_be_automatically_generated:
      'Nội dung Podcast sẽ được tạo tự động từ các nguồn Internet đáng tin cậy.',
    upload_or_select_file: 'Vui lòng tải lên hoặc chọn tập tin!',
    podcast_eposode_title: 'Tiêu đề tập Podcast',
    enter_podcast_title: 'Vui lòng nhập tiêu đề tập!',
    podcast_episode_des: 'Mô tả tập Podcast',
    enter_podcast_episode_des: 'Vui lòng nhập mô tả tập!',
    voice: 'Giọng nói',
    music: 'Âm nhạc',
    select_music: 'Chọn nhạc',
    play_the_music: 'Phát nhạc',
    stop_the_music: 'Dừng nhạc',
    context: 'Ngữ cảnh',
    generate_audio_content_selected_voice:
      'Tạo âm thanh từ nội dung theo giọng nói đã chọn.',
    required_field_before_submitting:
      'Vui lòng điền tất cả các trường bắt buộc trước khi gửi.',
    regenerate_voice: 'Tạo lại giọng nói',
    generate_voice: 'Tạo giọng nói',
    your_browser_does_not_suppot:
      'Trình duyệt của bạn không hỗ trợ phần tử âm thanh.',
    are_sure_leave_podcast: 'Bạn có chắc chắn muốn rời khỏi Podcast không?',
    broadcast_ongoing:
      'Buổi phát đang diễn ra. Bạn có chắc chắn muốn rời khỏi trang này?',
    brodcaster_unavailable: 'Người phát hiện không khả dụng vào lúc này.',
    setting_calender_for_booking: 'Đang thiết lập lịch để đặt chỗ',
    add_calender: 'Thêm lịch',
    waiting_join_host: 'Đang chờ người dẫn tham gia...',
    no_reviews_found: 'Không tìm thấy đánh giá nào.',
    rated_already: 'Bạn đã đánh giá sự kiện trực tiếp này rồi.',
    downlink_png: 'tải_png',
    downlink_jpg: 'tải_jpg',
    donwload_file_format: 'Vui lòng chọn định dạng tập tin bạn muốn tải xuống.',
    crashed_event:
      'Sự kiện này đã gặp sự cố. Bạn cần tạo sự kiện mới. Xin lỗi vì sự bất tiện.',
    prompt: 'Lời nhắc:',
    generated_image: '🚀 Đang tạo hình ảnh... Vui lòng đợi.',
    download_add: 'Tải xuống tất cả',
    setting_generator: 'Thiết lập công cụ tạo',
    enter_image_prompt: 'Vui lòng nhập lời nhắc hình ảnh',
    image_prompt: 'Nhập lời nhắc hình ảnh của bạn',
    negative_prompt: 'Lời nhắc phủ định',
    negative_image_prompt: 'Nhập lời nhắc phủ định hình ảnh của bạn',
    number_output: 'Số lượng đầu ra',
    enter_number_output: 'Vui lòng nhập số lượng đầu ra',
    image_style: 'Vui lòng chọn phong cách hình ảnh',
    output_format: 'Định dạng đầu ra',
    seeds: 'Hạt giống',
    enter_seeds: 'Vui lòng nhập số lượng hạt giống',
    performance_mode: 'Chế độ hiệu suất',
    quality: 'Chất lượng',
    speed: 'Tốc độ',
    balanced: 'Cân bằng',
    guidance_scale: 'Tỷ lệ hướng dẫn',
    enter_guidance: 'Vui lòng nhập tỷ lệ hướng dẫn',
    select_image: 'Vui lòng chọn hình ảnh.',
    image_prmt: 'Lời nhắc hình ảnh',
    generate_image_list_empty: 'Danh sách hình ảnh được tạo trống.',
    knowledge_center_tooltrip_des:
      'Nhận phản hồi ngắn gọn và chính xác theo ngữ cảnh cho nhiều loại câu hỏi kiến thức chung. Các phản hồi được tạo từ mô hình AI được huấn luyện với các văn bản đa dạng trên Internet.',
    contexts: 'Ngữ cảnh',
    ai_processing_video_sharebot:
      'Việc xử lý video bằng AI sẽ mất khoảng 24 giờ để hoàn tất và hiển thị trên Sharebot.',
    remove_sharebot_video: `Nếu bạn muốn xóa tham chiếu video khỏi Sharebot, vui lòng xóa cả bản ghi lời và video.`,
    remove_sharebot_video_audio:
      'Việc xóa bản ghi lời sẽ loại bỏ tham chiếu âm thanh/video trên Sharebot, nhưng video vẫn xuất hiện trong thư viện/channels.',
    monthly_live_stream:
      'Để thay đổi giới hạn phát trực tiếp hàng tháng, vui lòng liên hệ',
    monthly_transcribe_limit:
      'Để thay đổi giới hạn chuyển âm hàng tháng, vui lòng liên hệ',
    must_be_one_to_three_hundred: 'Phải từ 1 đến 300 phút.',
    all_field_required: 'Tất cả các trường đều bắt buộc.',
    duration_minute: 'Thời lượng (tối đa 300 phút)',
    gender: 'Giới tính',
    select_gender: 'Chọn giới tính',
    accent: 'Giọng vùng miền',
    select_accent: 'Chọn giọng vùng miền',
    create_voice: 'Tạo Giọng nói',
    enter_voice_name: 'Nhập Tên Giọng nói',
    select_voice_gender: 'Vui lòng chọn giới tính giọng nói',
    upload_voice: 'Tải Lên Giọng Nói Của Bạn',
    upload_voice_mp_three: 'Tải lên giọng nói của bạn (.mp3)',
    cloned_voice: 'Giọng nói được nhân bản',
    voice_type: 'Loại Giọng Nói',
    select_voice_type: 'Chọn Loại Giọng Nói',
    sharelook_stand: 'Tiêu chuẩn',
    sharelook_premium: 'Cao cấp',
    sharelook_custum_voice: 'Tùy chỉnh (Nhân bản giọng nói)',
    create_auto_flow: 'Tạo luồng tự động',
    how_many_layers: 'Bao nhiêu lớp',
    verify_selection: 'Xác minh lựa chọn',
    uploaded_successful: 'Tải lên thành công',
    upload_failed: 'Tải lên thất bại',
    upload_only_five_mb: 'Tải lên nội dung (tối đa 5 tệp PDF)',
    docs_from_org_library: 'Sử dụng tài liệu từ Thư viện tổ chức',
    failed_maze_generate: 'Không thể tạo mê cung. Vui lòng thử lại.',
    generate_metamaze: 'Đang tạo MetaMaze...',
    metamaze_being_generated:
      'MetaMaze của bạn đang được tạo. Bạn sẽ được thông báo qua email khi quá trình hoàn tất.',
    metamaze_generate_successfully: 'Tạo MetaMaze thành công!',
    metamaze_with_proceed: 'Bạn có thể tiếp tục với MetaMaze.',
    ai_metamaze_generate: 'Tạo MetaMaze bằng AI',
    what_kind_maze_create: 'Bạn muốn tạo loại mê cung nào?',
    manual_metamaze_creation: 'Tạo MetaMaze thủ công',
    manually_maze_customizing_scnario:
      'Tự tạo mê cung bằng cách tùy chỉnh kịch bản và cây lựa chọn',
    maze_ai_generated: 'Tự động tạo mê cung bằng AI',
    unmark_deadend: 'Bỏ đánh dấu điểm cụt',
    mark_deadend: 'Đánh dấu là điểm cụt',
    select_multiple_image_for_scenario:
      'Bạn có thể chọn nhiều hình ảnh cho kịch bản.',
    select_your_image: 'Hình ảnh bạn đã chọn',
    click_to_preview: 'Nhấp để xem trước',
    are_you_sure_delete_image: 'Bạn có chắc chắn muốn xóa hình ảnh này không?',
    select_image_from_library: 'Chọn hình ảnh từ Thư viện phương tiện',
    uploading_video: 'Đang tải video...',
    tree_node_type: 'Loại nút cây',
    correct_option_scenario: 'Lựa chọn hoặc kịch bản đúng',
    incorrect_option: 'Lựa chọn sai',
    option_scenario_without_text: 'Lựa chọn hoặc kịch bản không có văn bản',
    dead_end: 'Điểm cụt (Viền đỏ)',
    correct_path: 'Đường đi đúng',
    incorrect_path_not_selected_correct_option_path:
      'Đường sai / Đường không chọn đúng lựa chọn.',
    double_click_on_tree_node:
      'Khi bạn nhấp đúp vào một nút cây, trình chỉnh sửa văn bản sẽ tự động cuộn để hiển thị nội dung của nút đó.',
    add_scenario: 'Thêm Kịch bản',
    add_option: 'Thêm Lựa chọn',
    an_error_occured: 'Đã xảy ra lỗi:',
    download_summary: 'Tải xuống Tóm tắt',
    step_wise_analysis: 'Phân tích Theo Bước',
    step: 'Bước',
    upload_csv_file: 'Tải lên Tệp CSV',
    download_template_to_import: 'Tải xuống mẫu để nhập',
    please_input_email: 'Vui lòng nhập email.',
    email_at_least_three_characters: 'Email phải có ít nhất 3 ký tự.',
    email_cannot_be_empty: 'Email không được để trống.',
    input_email_in_new_line: 'Vui lòng nhập email (mỗi email một dòng)',
    role: 'Vai trò',
    select_role: 'Vui lòng chọn Vai trò',
    select_group: 'Vui lòng chọn Nhóm',
    identification_number: 'Số nhận dạng (Tùy chọn)',
    add_identification_number: 'Vui lòng thêm Số nhận dạng',
    pie_chart_of_all_categories:
      'Biểu đồ tròn của tất cả các danh mục dựa trên mức sử dụng trong Sharelook.',
    total_sharesphere_question_answered_by_users:
      'Tổng số câu hỏi ShareSphere được người dùng trong tổ chức trả lời, kèm theo kết quả thành công và thất bại theo danh mục.',
    voice_style_over_the_text: `Bạn có thể sử dụng nhiều phong cách giọng nói khác nhau cho văn bản bạn nhập bla bla bla. Lorem Ipsum chỉ là văn bản giả dùng trong ngành in ấn và sắp chữ.`,
    input_your_question: 'Vui lòng nhập câu hỏi của bạn!',
    make_me_sales_manager:
      'ví dụ: Điều gì khiến tôi trở thành quản lý bán hàng',
    enter_the_number_relevant_document: 'Nhập số lượng tài liệu liên quan',
    please_wait_loading_result: 'Vui lòng đợi, đang tải kết quả...',
    no_result_found: 'Không tìm thấy kết quả, hãy thử đặt câu hỏi khác',
    browser_doesnot_support_iframes: 'Trình duyệt của bạn không hỗ trợ iframe',
    total_duration: 'Tổng Thời Gian',
    number_of_messages: 'Số Lượng Tin Nhắn',
    search_result: 'Kết quả Tìm kiếm',
    count_result: '(1244 kết quả)',
    your_other_interests: 'Các mối quan tâm khác của bạn',
    your_total_score: 'Tổng điểm của bạn',
    add_a_question: '+thêm câu hỏi',
    travia_question_empty: 'Danh sách câu hỏi Travia trống.',
    video_generation_is_on_queue: 'Video của bạn đang được xử lý!',
    checking_video_status: 'Đang kiểm tra trạng thái video...',
    total_quizzes: 'Tổng số Bài kiểm tra',
    number_of_votes: 'Số Phiếu bầu',
    total_events: 'Tổng số Sự kiện',
    number_of_rates: 'Số lượt đánh giá',
    number_of_likes: 'Số lượt thích',
    all_courses: 'Tất cả các Khóa học',
    total_questions: 'Tổng số Câu hỏi',
    no_skill_journey: 'Không có hành trình kỹ năng nào!',
    search_no_results: '- không có kết quả!',
    no_image_generated: 'Chưa tạo hình ảnh nào!',
    all_topic_in_this_lesson:
      'Tất cả các chủ đề trong bài học này sẽ bị xóa. Hành động này không thể hoàn tác.',
    content_has_been_generated: 'Nội dung đã được tạo cho chủ đề này.',
    update_course_template: 'Cập nhật Mẫu khóa học',
    add_course_template: 'Thêm Mẫu khóa học',
    create_course_now: 'Tạo Khóa học Ngay',
    preview_course: 'Xem trước Khóa học',
    layout: 'Bố cục',
    import_from_youtube: 'Nhập từ YouTube',
    my_media_library: 'Thư viện phương tiện của tôi',
    bg_added: 'Đã thêm nền',
    add_bg: 'Thêm Nền',
    booked_schedule: 'Lịch đã được đặt',
    add_schedule: 'Thêm Lịch',
    are_you_delete_schedule: 'Bạn có chắc chắn muốn xóa lịch này không?',
    add_task: 'Thêm Nhiệm vụ',
    update_calender: 'Cập nhật Lịch',
    manage_cookies: 'Quản lý Cookie',
    cookie_banner_text:
      'Chúng tôi sử dụng cookie để nâng cao trải nghiệm duyệt web của bạn, phân tích lưu lượng truy cập trang web và cá nhân hóa nội dung. Quyền riêng tư của bạn rất quan trọng đối với chúng tôi.',
    accept_all_cookies: 'Chấp nhận tất cả Cookie',
    reject_all: 'Từ chối tất cả',
    customize: 'Tùy chỉnh',
    cookie_preferences_title: 'Cài đặt Quyền riêng tư & Cookie',
    privacy_subtitle:
      'Quyền riêng tư của bạn quan trọng đối với chúng tôi. Chọn những cookie mà bạn cảm thấy thoải mái. Bạn có thể thay đổi cài đặt này bất kỳ lúc nào.',
    save_choices: 'Lưu lựa chọn của tôi',
    strictly_necessary: 'Cần thiết tuyệt đối',
    strictly_necessary_desc:
      'Các cookie này cần thiết để trang web hoạt động đúng. Chúng cho phép các chức năng cơ bản như điều hướng trang, gửi biểu mẫu và truy cập các khu vực an toàn. Trang web không thể hoạt động bình thường nếu không có chúng.',
    analytics_performance: 'Phân tích & Hiệu suất',
    analytics_performance_desc:
      'Các cookie này giúp chúng tôi hiểu cách khách truy cập tương tác với trang web bằng cách thu thập và báo cáo thông tin ẩn danh. Điều này giúp cải thiện hiệu suất và trải nghiệm người dùng.',
    advertising_marketing: 'Quảng cáo & Tiếp thị',
    advertising_marketing_desc:
      'Các cookie này được sử dụng để làm cho thông điệp quảng cáo phù hợp hơn với bạn. Chúng ngăn cùng một quảng cáo xuất hiện liên tục và đảm bảo quảng cáo được hiển thị đúng cho nhà quảng cáo.',
    tracking_social: 'Theo dõi & Mạng xã hội',
    tracking_social_desc:
      'Các cookie này cung cấp chức năng nâng cao và cá nhân hóa, chẳng hạn như tính năng mạng xã hội và nội dung cá nhân hóa. Chúng có thể được đặt bởi chúng tôi hoặc các nhà cung cấp bên thứ ba.',
    functional: 'Chức năng',
    functional_desc:
      'Các cookie này cung cấp chức năng nâng cao như hỗ trợ chat, trợ giúp trực tiếp và các tính năng tương tác khác cải thiện trải nghiệm trên trang web.',
    your_rights: 'Quyền của bạn:',
    rights_description:
      'Bạn có thể rút lại sự đồng ý bất cứ lúc nào, truy cập dữ liệu của bạn hoặc yêu cầu xóa dữ liệu.',
    withdraw_consent: 'Rút lại tất cả sự đồng ý',

    how_many_options: 'Bao nhiêu tùy chọn',
    add_content: 'Thêm nội dung',
    downloads_center: 'Trung tâm Tải xuống',
    sharelook_help_center: 'Trung tâm Trợ giúp Sharelook',
    channel_outline: 'Phác thảo Kênh',
    channel_objectives: 'Mục tiêu Kênh',
    no_sop_available: 'Không có danh sách SOP.',
    generate_world_summary: 'Tạo Kịch bản',
    world_scenario: 'Kịch bản Thế giới Thực',
    drag_icon_hint: 'Mẹo: Kéo biểu tượng trên canvas để định vị',
    drag_text_hint: 'Mẹo: Kéo văn bản trên canvas để định vị',
    edit_badge: 'Chỉnh sửa Huy hiệu',
    create_new_badge: 'Huy hiệu Mới',
    select_video_preview: 'Chọn video để xem trước',
    certificate_title_required: 'Tiêu đề Chứng chỉ là bắt buộc',
    discard_changes: 'Bỏ thay đổi',
    edit_certificate: 'Chỉnh sửa Chứng chỉ',
    add_another_logo: 'Thêm Logo khác',
    optional: 'Tùy chọn',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Tạo Nhiệm vụ Mới',
    quest_filter_title: 'Nhiệm vụ',
    sharelook_assistance: 'Hỗ trợ Sharelook',
    upload_scorm_zip: 'Tải lên SCORM Zip',
    only_letters_numbers_space_dot_allowed:
      'Chỉ cho phép chữ cái, số, khoảng trắng và dấu chấm!',
    video_playing: 'Đang phát',
    course_price_message:
      '*Khóa học sẽ chỉ được xuất bản cho người dùng trong tổ chức và không thể bán trên thị trường.',
    lesson_must_be_positive: 'Số bài học phải lớn hơn 1',
    btn_proceed: 'Tiếp tục',
    rule_select_music: 'Vui lòng chọn nhạc',
    course_info: 'Thông tin Khóa học',
    content_selection: 'Chọn Nội dung',
    course_content_source: 'Nguồn Nội dung Khóa học',
    choose_how_to_source: 'Chọn cách lấy nội dung cho khóa học này:',
    automatic_selection: 'Chọn tự động',
    system_will_automatically_select_relavant_documents:
      'Hệ thống sẽ tự động chọn các tài liệu liên quan từ thư viện của bạn',
    manual_selection: 'Chọn thủ công',
    choose_specific_documents_from_your_library:
      'Chọn các tài liệu cụ thể từ thư viện của bạn',
    upload_files: 'Tải tệp lên',
    upload_new_documents:
      'Tải tài liệu mới lên (PDF, DOC, DOCX, PPT, PPTX, TXT) - Tối đa 5 tệp',
    file: 'tệp',
    ready_to_upload: 'sẵn sàng tải lên',
    clear_all: 'Xóa tất cả',
    confirm_course_wide_premiew: 'Xác nhận Xem trước Toàn khóa học',
    generate_course_preview: 'Tạo Xem trước Khóa học',
    instructions_across_the_course_to_generate:
      'Chúng tôi sẽ áp dụng hướng dẫn của bạn trên toàn khóa học để tạo bản xem trước. Kiểm tra tất cả trước khi quyết định giữ hay bỏ thay đổi.',
    instruction_to_preview_course_wide: 'Hướng dẫn để xem trước toàn khóa học:',
    edit_content: 'Chỉnh sửa Nội dung',
    manage_course_template: 'Quản lý Mẫu Khóa học',
    undo: 'Hoàn tác',
    apply_changes: 'Áp dụng Thay đổi',
    characters: 'ký tự',
    apply_all: 'Áp dụng Tất cả',
    apply_to_all: 'Áp dụng cho tất cả',
    use_this_content: 'Sử dụng Nội dung này',
    original: 'Nguyên bản',
    edited: 'Đã chỉnh sửa',
    edited_content_preview: 'Xem trước Nội dung Đã chỉnh sửa',
    apply_edits_to_all_topices: 'Áp dụng chỉnh sửa cho tất cả các chủ đề?',
    current_editing_instructions_across_the_whole_course:
      'Điều này sẽ áp dụng các hướng dẫn chỉnh sửa hiện tại trên toàn khóa học. Bạn có thể xem trước kết hợp trước khi lưu.',
    edit_content_instructions: 'Hướng dẫn Chỉnh sửa Nội dung',
    generate_content_for_this_topic_instruction:
      'Tạo nội dung cho chủ đề này bằng hướng dẫn của bạn',
    descrip_edit_content:
      'Mô tả cách chỉnh sửa nội dung này (ví dụ: rút gọn, đơn giản hóa, viết lại)',
    try_short_clear_direcctives:
      'Hãy thử các chỉ dẫn ngắn gọn và rõ ràng. Ví dụ: "rút gọn còn 100 từ, giữ các điểm chính", "đơn giản hóa ngôn ngữ", "ngắn gọn hơn và loại bỏ phần thừa".',
    we_preserve_the_core_meaning:
      'Chúng tôi giữ nguyên ý nghĩa cốt lõi khi áp dụng hướng dẫn của bạn.',
    feedback_optional: 'Phản hồi (Tùy chọn)',
    write_your_feedback_here: 'Viết phản hồi của bạn tại đây',
    from_web: 'Từ Web',
    from_desktop: 'Từ Máy tính',
    pleae_wait_processing: 'Vui lòng đợi xử lý...',
    create_simulation_from_screen_capture: 'Tạo Mô phỏng từ Ảnh chụp Màn hình',
    sharelook_not_found: 'Không tìm thấy ShareLook',
    sharelook_screen_capture_application_not_be_opened:
      'Không thể mở ứng dụng ShareLook Screen Capture. Có thể chưa được cài đặt trên máy tính của bạn.',
    download_sharelook: 'Tải ShareLook',
    launch_sharelook_application: 'Mở Ứng dụng ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Điều này sẽ mở ứng dụng ShareLook để chụp màn hình.',
    sharelook_dosenot_open:
      'Nếu ShareLook không mở, có thể nó chưa được cài đặt trên máy tính của bạn.',
    open_sharelook: 'Mở ShareLook',
    download_app: 'Tải Ứng dụng',
    background_image_setting: 'Cài đặt Hình nền',
    current_image: 'Hình hiện tại',
    change_image: 'Thay đổi Hình',
    remove_image: 'Xóa Hình',
    no_background_image_selected: 'Chưa chọn hình nền',
    add_image: 'Thêm Hình',
    this_will_open_for_screen_recording:
      'Điều này sẽ mở ứng dụng ShareLook để ghi màn hình.',
    ai_image_generation: 'Tạo Hình bằng AI',
    image_edit: 'Chỉnh sửa Hình',
    text_to_image: 'Chuyển Văn bản thành Hình',
    output_gallary: 'Thư viện Đầu ra',
    instant_generation: 'Sẵn sàng tạo ngay',
    prompt_and_unleash_the_power: 'Nhập yêu cầu và giải phóng sức mạnh',
    use_this_image: 'Sử dụng Hình này',
    error_generating: 'Lỗi khi tạo hình.',
    generation_tips: 'Mẹo tạo hình',
    detailed_descriptions_for_more_accurate_results:
      'Sử dụng mô tả chi tiết để có kết quả chính xác hơn',
    reference_image: 'Hình Tham khảo',
    select_pixel_image: 'Chọn Hình Pixel',
    max_mb: 'Tối đa 50MB',
    please_enter_text_to_appear_image:
      'Vui lòng nhập văn bản xuất hiện trong hình',
    enter_text_to_apear_in_the_image: 'Nhập văn bản xuất hiện trong hình',
    generate_image: 'Tạo Hình',
    prompt_assistant: 'Trợ lý Yêu cầu',
    generate_image_using_suggested_prompt:
      'Tạo hình sử dụng yêu cầu được gợi ý',
    talk_to_ai_about_the_image_generate: 'Trao đổi với AI về hình bạn muốn tạo',
    ask_for_prompt_suggestions: 'Yêu cầu gợi ý yêu cầu...',
    enter_a_search_term_to_find_stock_images: 'Nhập từ khóa để tìm hình stock',
    choose_your_content_source: 'Chọn nguồn nội dung của bạn:',
    upload_new_document_from_your_device:
      'Tải lên tài liệu mới từ thiết bị của bạn',
    automatic_library_selection: 'Chọn Thư viện Tự động',
    system_automatically_selects_relevant_document:
      'Hệ thống tự động chọn tài liệu liên quan',
    manual_library_selection: 'Chọn Thư viện Thủ công',
    generate_content: 'Tạo Nội dung',
    add_to_current_page: 'Thêm vào Trang hiện tại',
    generate_bullet_points: 'Tạo Các điểm chính',
    generating: 'Đang tạo',
    this_may_take_a_few_moments: 'Việc này có thể mất một vài phút',
    apply_to_page: 'Áp dụng vào Trang',
    scenario_escription: 'Mô tả Kịch bản:',
    feedback: 'Phản hồi',
    form_mode: 'Chế độ Biểu mẫu',
    chat_mode: 'Chế độ Trò chuyện',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Điều này sẽ tạo phần tiếp theo của câu chuyện đã chọn bằng AI.',
    continue_this_story_question: 'Tiếp tục câu chuyện này?',
    continue_this_story: 'Tiếp tục Câu Chuyện Này',
    what_will_happen: 'Điều gì sẽ xảy ra:',
    the_ai_will_analyze_the_existing_story_content:
      'AI sẽ phân tích nội dung câu chuyện hiện có',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Tạo phần tiếp theo tự nhiên theo cùng giọng điệu và phong cách',
    create_new_content_that_build_upon_the_current_narrative:
      'Tạo nội dung mới dựa trên mạch truyện hiện tại',
    this_process_may_take_a_few_moments_to_complete:
      'Quá trình này có thể mất vài giây để hoàn thành.',
    no_existing_stories_found_for_this_course:
      'Không tìm thấy câu chuyện nào cho khóa học này.',
    create_your_first_story: 'Tạo Câu Chuyện Đầu Tiên Của Bạn',
    existing_stories: 'Câu Chuyện Hiện Có',
    create_new_story: 'Tạo Câu Chuyện Mới',
    tone: 'Giọng điệu',
    style: 'Phong cách',
    genre: 'Thể loại',
    loading_your_stories: 'Đang tải các câu chuyện của bạn...',
    edit_story: 'Chỉnh sửa Câu Chuyện',
    story_preferences: 'Tùy chọn Câu Chuyện',
    please_input_your: 'Vui lòng nhập',
    add_character_names_and_press_enter: 'Thêm tên nhân vật và nhấn Enter',
    select_or_type_your: 'Chọn hoặc nhập',
    enter_your: 'Nhập',
    position_of_the_story_in_the_lesson:
      'Vị trí của câu chuyện trong bài học. Câu chuyện sẽ được thêm dưới dạng một khối tại vị trí được chỉ định.',
    save_previous_content_on_the_pages: 'Lưu nội dung trước đó trên các trang',
    the_existing_content_in_the_selected_pages:
      'Nội dung hiện có trên các trang được chọn sẽ được thay thế bằng câu chuyện được tạo.',
    real_world_scenario: 'Kịch Bản Thực Tế',
    add_optional_instructions:
      'Thêm hướng dẫn tùy chọn (giọng điệu, độ dài, đối tượng, v.v.)',
    ready_to_enerate_your_real_world_scenario:
      'Sẵn sàng tạo Kịch Bản Thực Tế của bạn',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Nhấn "Tạo Kịch Bản Thực Tế" để tạo kịch bản thực tế dựa trên nội dung bài học của bạn.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI sẽ phân tích chủ đề và nội dung bài học của bạn',
    generate_a_practical_real_world_scenario:
      'Tạo kịch bản thực tế và thiết thực',
    you_can_then_edit_and_customize_the_result:
      'Bạn có thể chỉnh sửa và tùy chỉnh kết quả',

    add_it_as_a_new_page_to_your_lesson:
      'Thêm nó làm trang mới cho bài học của bạn',
    regenerate_with_instructions: 'Tạo lại với Hướng dẫn',
    add_real_world_scenario: 'Thêm Kịch Bản Thực Tế',
    generate_real_world_scenario: 'Tạo Kịch Bản Thực Tế',
    simulation_has_been_stopped: 'Mô phỏng đã dừng!',
    loading_simulation: 'Đang tải Mô phỏng...',
    you_have_exhausted_all_the_attempts: 'Bạn đã hết tất cả lượt thử',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Nghiên cứu kịch bản trên trang này và chọn câu trả lời đúng từ các lựa chọn bên dưới.',
    attempts_limit_reached:
      'Đã đạt giới hạn lượt thử. Bạn có thể chơi lại nhưng điểm của bạn sẽ không được lưu.',
    play_again: 'Chơi Lại',
    import_music_from_computer: 'Nhập nhạc từ máy tính.',
    more: 'thêm',
    no_badge_yet: 'Chưa có huy hiệu',
    competition_filter: 'Bộ Lọc Cuộc Thi',
    global_leaderboard: 'Bảng Xếp Hạng Toàn Cầu',
    placeholder_for_the_global_leaderboard:
      'Đây là chỗ giữ chỗ cho Bảng Xếp Hạng Toàn Cầu.',
    badge_editor: 'Trình Chỉnh Sửa Huy Hiệu',
    adjust_the_appearance_of_this_badge_icon:
      'Điều chỉnh giao diện biểu tượng huy hiệu này. Thay đổi chỉ áp dụng cho huy hiệu này.',
    badge_style: 'Phong Cách Huy Hiệu',
    the_image_must_be_pixels: 'Hình ảnh phải có kích thước 200x200 pixel.',
    badge_name: 'Tên Huy Hiệu',
    badge_descrription: 'Mô tả Huy Hiệu',
    enter_badge_criteria: 'Nhập tiêu chí huy hiệu',
    discard: 'Hủy',
    badge_enable: 'Bật Huy Hiệu',
    award_users_with_badges_to_highlight_the_milestones:
      'Trao huy hiệu cho người dùng để làm nổi bật các cột mốc trong hành trình học tập của họ.',
    badge_types: 'Loại Huy Hiệu',
    enable_or_disable_specific_badge_types_for_your_users:
      'Bật hoặc tắt các loại huy hiệu cụ thể cho người dùng của bạn.',
    levels_enabled: 'Bật Cấp Bậc',
    level_rules: 'Quy tắc Cấp Bậc',
    points: 'Điểm',
    add_new_level: 'Thêm Cấp Bậc Mới',
    add_level: 'Thêm Cấp Bậc',
    points_enabled: 'Bật Điểm',
    learning_activities_and_encourage_healthy_competition:
      'Trao điểm cho người dùng cho các hoạt động học tập khác nhau và khuyến khích cạnh tranh lành mạnh.',
    award_points: 'Trao Điểm',
    the_following_equates_the_value_of_one_item_completion:
      'Sau đây tương đương với giá trị của việc hoàn thành một mục',
    general: 'Chung',
    others: 'Khác',
    certificate: 'Chứng Chỉ',
    quiz_passed: 'Đã vượt qua bài kiểm tra',
    tip_approved: 'Mẹo được phê duyệt',
    tip_liked: 'Mẹo được thích',
    rewards: 'Phần Thưởng',
    offer_discounts_when_learners_achieve:
      'Cung cấp giảm giá khi người học đạt một số điểm, huy hiệu hoặc cấp bậc nhất định.',
    give_rewards: 'Trao Phần Thưởng',
    discount_course_purchases_by: 'Giảm giá mua khóa học',
    with_points_more_than: 'với điểm lớn hơn',
    with_badges_more_than: 'với huy hiệu nhiều hơn',
    with_level_upwards_more_than: 'với cấp bậc cao hơn',
    leaderboard: 'Bảng Xếp Hạng',
    leaderboard_enabled: 'Bật Bảng Xếp Hạng',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Bảng xếp hạng cung cấp cái nhìn tổng quan về tiến trình học tập của người dùng so với người khác.',
    show_levels: 'Hiển thị Cấp Bậc',
    show_points: 'Hiển thị Điểm',
    show_badges: 'Hiển thị Huy Hiệu',
    show_courses: 'Hiển thị Khóa Học',
    show_certificates: 'Hiển thị Chứng Chỉ',
    leaderboard_settings: 'Cài Đặt Bảng Xếp Hạng',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Thiết lập trải nghiệm bảng xếp hạng hấp dẫn để tăng động lực học tập.',
    award_users_with_points_for_different_learning_activities:
      'Trao điểm cho người dùng cho các hoạt động học tập khác nhau.',
    badge_set: 'Bộ Huy Hiệu',
    choose_the_type_of_badges_your_users:
      'Chọn loại huy hiệu mà người dùng sẽ nhận được trong quá trình học.',
    levels: 'Cấp Bậc',
    Levels_represent_the_stages:
      'Cấp bậc đại diện cho các giai đoạn trong hành trình học tập của người dùng.',
    enabled: 'Bật',
    disabled: 'Tắt',
    quick_select: 'Chọn Nhanh',
    yesterday: 'Hôm qua',
    last_week: 'Tuần trước',
    Last_month: 'Tháng trước',
    last_quarter: 'Quý trước',
    historical_leaderboard: 'Bảng Xếp Hạng Lịch Sử',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Theo dõi hiệu suất của bạn và xem bạn xếp hạng như thế nào so với đồng nghiệp',
    time_period: 'Khoảng thời gian',
    page_of: 'Trang 1 của 1',
    edit_competition: 'Chỉnh sửa Cuộc Thi',
    create_competition: 'Tạo Cuộc Thi',
    arrow_right: 'mũi tên phải',
    update_competition: 'Cập nhật Cuộc Thi',
    competition_title: 'Tiêu đề Cuộc Thi',
    enter_competition_title: 'Nhập tiêu đề cuộc thi',
    enter_competition_description: 'Nhập mô tả cuộc thi',
    leaderboard_skill: 'Kỹ Năng',
    select_a_skill: 'Chọn một kỹ năng',
    no_skills_found: 'Không tìm thấy kỹ năng',
    competition_period: 'Thời Gian Cuộc Thi',
    add_badge_rule: 'Thêm Quy Tắc Huy Hiệu',
    create_badge: 'Tạo Huy Hiệu',
    add_level_rule: 'Thêm Quy Tắc Cấp Bậc',
    selected_participants: 'Người Tham Gia Đã Chọn',
    no_participants: 'Không có người tham gia',
    start_end_date: 'Ngày Bắt Đầu – Kết Thúc',
    created_date: 'Được tạo bởi',
    new_competition: 'Cuộc Thi Mới',
    competitions_list: 'Danh Sách Cuộc Thi',
    search_competitions: 'Tìm kiếm cuộc thi...',
    are_you_sure_you_want_to_delete_the_competition:
      'Bạn có chắc chắn muốn xóa cuộc thi này không?',
    history: 'Lịch Sử',
    export: 'Xuất',
    search_by_name: 'Tìm theo tên...',
    no_historical_data_available_for_the_selected_period:
      'Không có dữ liệu lịch sử cho khoảng thời gian đã chọn.',
    no_leaderboard_data_available: 'Không có dữ liệu bảng xếp hạng.',
    competitions: 'Cuộc Thi',
    leaderboards: 'Bảng Xếp Hạng',
    welcome_back: 'Chào Mừng Trở Lại',
    track_your_performance_and_see:
      'Theo dõi hiệu suất của bạn và xem xếp hạng của bạn',
    team_leaderboard: 'Bảng Xếp Hạng Nhóm',
    try_again: 'Thử Lại',
    no_competitions_for_search: 'Không có cuộc thi cho tìm kiếm',
    no_competitions_available: 'Không có cuộc thi nào',
    no_competitions_matching_search:
      'Không tìm thấy cuộc thi phù hợp với tìm kiếm. Thử điều chỉnh từ khóa hoặc quay lại sau.',
    no_competitions_general:
      'Hiện chưa có cuộc thi nào được thiết lập. Quay lại sau hoặc liên hệ quản trị viên để tạo cuộc thi mới.',
    media_management: 'Quản Lý Media',
    badgess_set: 'Bộ Huy Hiệu',
    choose_the_default_visual_style_for_badge:
      'Chọn phong cách trực quan mặc định cho biểu tượng huy hiệu trên toàn nền tảng',
    enable_badges: 'Bật Huy Hiệu',
    add_badge: 'Thêm Huy Hiệu',
    min: 'Tối Thiểu',
    max: 'Tối Đa',
    your_rank: 'Xếp Hạng Của Bạn',
    your_points: 'Điểm Của Bạn',
    your_level: 'Cấp Bậc Của Bạn',
    rank: 'Hạng #',
    level: 'Cấp Bậc',
    progress: 'Tiến Trình',
    new_folder: 'Thư Mục Mới',
    file_upload: 'Tải Tệp Lên',
    writer: 'Người Viết',
    text_documents: 'Tài Liệu Văn Bản',
    spreadsheets: 'Bảng Tính',
    impress: 'Trình Chiếu',
    presentations: 'Bài Thuyết Trình',
    capture_desktop_screen: 'Chụp Màn Hình Máy Tính',
    capture_desktop_screens: 'Chụp Nhiều Màn Hình Máy Tính',
    your_documents: 'Tài Liệu Của Bạn',
    manage_your_videos_images_audio_files:
      'Quản lý video, hình ảnh, tệp âm thanh và các tài sản khác dùng trong việc tạo nội dung của bạn',
    your_organization_documents: 'Tài Liệu Tổ Chức Của Bạn',
    keep_your_organization_creative_assets_organized:
      'Giữ tài sản sáng tạo của tổ chức bạn được sắp xếp và dễ truy cập—tinh gọn công việc nhóm và sản xuất nội dung',
    your_public_documents: 'Tài Liệu Công Cộng Của Bạn',
    curated_collection_of_media_assets_available:
      'Bộ sưu tập tài sản truyền thông được tuyển chọn sẵn có cho mọi người—khám phá, tái sử dụng và sáng tạo',
    your_download_center_documents: 'Tài Liệu Trung Tâm Tải Xuống Của Bạn',
    repository_of_approved_media_assets_for_download:
      'Kho lưu trữ tài sản truyền thông được phê duyệt để tải xuống và sử dụng trong dự án của bạn',
    search_files_and_folders: 'Tìm kiếm tệp và thư mục..',
    home: 'Trang Chủ',
    folders: 'Thư Mục',
    folder_name: 'Tên Thư Mục',
    owner: 'Chủ sở hữu',
    last_updated: 'Cập nhật lần cuối',
    action: 'Hành động',
    no_folders_found: 'Không tìm thấy thư mục',
    files: 'Tệp',
    enabling_ai: 'Đang kích hoạt AI...',
    rename: 'Đổi Tên',
    copy: 'Sao Chép',
    move: 'Di Chuyển',
    verson_history: 'Lịch Sử Phiên Bản',
    manage_permission: 'Quản Lý Quyền',
    generate_audit_report: 'Tạo Báo Cáo Kiểm Toán',
    last_edited: 'Chỉnh sửa lần cuối',
    no_files_found: 'Không tìm thấy tệp',
    are_you_sure_you_want_to_make_this_item_public:
      'Bạn có chắc chắn muốn công khai mục này không? Nó sẽ được sao chép vào thư viện công cộng của bạn.',
    move_to_organization: 'Di chuyển đến Tổ Chức',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Bạn có chắc chắn muốn sao chép mục này vào thư viện tổ chức của bạn không?',
    are_you_sure_you_want_to_make_this_item_private:
      'Bạn có chắc chắn muốn đặt mục này thành riêng tư không? Nó sẽ được sao chép vào thư viện của bạn.',
    date_modified: 'Ngày Chỉnh Sửa',
    workflow_management: 'Quản Lý Quy Trình Làm Việc',
    configure_editors_approvers_and_viewers_for_this_document:
      'Cấu hình biên tập viên, người phê duyệt và người xem cho tài liệu này',
    error_Loading_editor: 'Lỗi khi tải trình chỉnh sửa',
    debug_info: 'Thông Tin Gỡ Lỗi',
    loading_editor: 'Đang tải Trình Chỉnh Sửa...',
    submitted_for_review: 'Đã gửi để xem xét',
    editors: 'Biên tập viên',
    no_editors_added_yet:
      'Chưa có biên tập viên nào được thêm. Nhấn "Thêm biên tập viên" để thêm.',
    add_editor: 'Thêm Biên Tập Viên',
    approvers: 'Người Phê Duyệt',
    no_approvers_added_yet:
      'Chưa có người phê duyệt nào được thêm. Nhấn "Thêm người phê duyệt" để thêm.',
    add_approvers: 'Thêm Người Phê Duyệt',
    viewer: 'Người Xem',
    no_viewers_added_yet:
      'Chưa có người xem nào được thêm. Nhấn "Thêm người xem" để thêm.',
    add_viewer: 'Thêm Người Xem',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Bạn có chắc chắn muốn xóa các mục đã chọn không?'
  },
  v3: {
    reportShareSphere: 'Chia sẻ Quả cầu',
    overview: 'Tổng quan khảo sát cộng đồng',
    triviaReport: 'ShareSphere Câu đố',
    overviewGraph: 'Biểu đồ tổng quan cộng đồng',
    category: 'Danh mục',
    phCategory: 'Chọn danh mục',
    podcast: 'Podcast, Âm nhạc và Câu chuyện',
    pastPodcast: 'Podcast đã phát',
    upcomingPodcast: 'Podcast sắp tới',
    podcastLanguageTitle: 'Ngôn ngữ Podcast, Âm nhạc và Câu chuyện',
    podcastLanguageCheckbox: 'Sử dụng dịch vụ AI cho ngôn ngữ podcast của tôi',
    howRate: 'Bạn đánh giá podcast này như thế nào?',
    podcastSubmit: 'Gửi',
    podcastGuest: 'Khách mời:',
    podcastReview: 'Đánh giá',
    podcastEpishode: 'Tập',
    podcastEnd: 'Podcast đã kết thúc',
    date_podcast: 'Ngày Podcast',
    skill_not_found: 'Rất tiếc! Không tìm thấy hành trình kỹ năng nào',
    coaching: 'Huấn luyện',
    webinar: 'Hội thảo trực tuyến',
    public_conference: 'Hội nghị công khai',
    skill_journey_subtitle:
      'Chọn kỹ năng và kiểm soát ai có thể xem và liên hệ với bạn',
    enable_white_label: 'Kích hoạt White Label',
    create_new_event_org: 'Tạo sự kiện mới cho tổ chức của bạn',
    create_new_event_marketplace: 'Tạo sự kiện mới cho thị trường',
    create_new_event_both: 'Tạo sự kiện mới cho tổ chức và thị trường',
    event_outline: 'Nhập đề cương sự kiện',
    event_obj: 'Nhập mục tiêu sự kiện',
    event_description: 'Nhập mô tả sự kiện',
    create_new_metamaze_org: 'Tạo Metamaze mới cho tổ chức của bạn',
    create_new_metamaze_marketplace: 'Tạo Metamaze mới cho thị trường',
    create_new_metamaze_both: 'Tạo Metamaze mới cho tổ chức và thị trường',
    add_key_words: 'Thêm từ khóa',
    press_enter_make_keyword: 'Nhấn Enter để tạo từ khóa',
    disable_skip_quiz: 'Tắt bỏ qua bài kiểm tra',
    warning_complete_quiz: 'Vui lòng hoàn thành bài kiểm tra để tiếp tục',
    signup_email_verification:
      'Liên kết xác minh đã được gửi đến email của bạn, vui lòng nhấp vào',
    verifying_registration: 'Đang xác minh đăng ký...',
    reset_password_linK:
      'Liên kết đặt lại mật khẩu đã được gửi đến email của bạn, vui lòng nhấp vào',
    reset_email_error:
      'Không tìm thấy tài khoản nào với email này, vui lòng thử tên người dùng khác',
    first_name: 'Tên',
    last_name: 'Họ',
    error_firstName: 'Vui lòng nhập tên của bạn',
    error_sharebot_organization: 'Vui lòng nhập tên tổ chức',
    error_lastName: 'Vui lòng nhập họ của bạn',
    private_conference: 'Hội nghị riêng tư',
    public_conference: 'Hội nghị công khai',
    discussion_room: 'Phòng thảo luận',
    training_no_courses: 'Bạn chưa tham gia khóa học nào',
    training_no_events: 'Bạn chưa tham gia sự kiện nào',
    allow_sharing_trainer_info:
      'Cho phép chia sẻ email của huấn luyện viên trên thị trường',
    error_username_space: 'Tên người dùng không được chứa dấu cách',
    error_sharebot_organization_space: 'Tên tổ chức không được chứa dấu cách',
    edit_permission: 'Chỉnh sửa quyền',
    valid_price: 'Giá phải lớn hơn 0',
    course_price_message:
      '*Khóa học này chỉ dành cho sử dụng nội bộ và không thể bán trên thị trường',
    valid_edit_price: 'Giá chỉnh sửa phải thấp hơn giá mua',
    my_calendar: 'Lịch của tôi',
    error_valid_firstName: 'Nhập tên hợp lệ',
    error_valid_organization: 'Nhập tên tổ chức hợp lệ',
    error_valid_lastName: 'Nhập họ hợp lệ',
    error_name_spaces: 'Tên không được chứa dấu cách',
    items: 'Mục',
    publish_to_channel: 'Xuất bản lên kênh của tôi',
    create_a_channel: 'Tạo kênh',
    create_a_trivia: 'Tạo câu đố',
    create_a_new_channel: 'Tạo kênh mới',
    add_videos: 'Thêm video',
    save_and_continue: 'Lưu và tiếp tục',
    channel: 'Kênh',
    channels: 'Tất cả kênh',
    view_channel: 'Xem kênh',
    edit_channel: 'Chỉnh sửa kênh',
    delete_channel: 'Xóa kênh',
    my_video_channels: 'Kênh video của tôi',
    training_no_channel: 'Bạn chưa tham gia kênh nào',
    monthly_price_required: 'Cần nhập giá hàng tháng',
    yearly_price_required: 'Cần nhập giá hàng năm',
    one_time_price_required: 'Cần nhập giá một lần',
    marketplace_quantity: 'Số lượng',
    report_webinar: 'Hội thảo trực tuyến',
    report_coaching: 'Huấn luyện',
    report_channel: 'Kênh',
    report_public_conference: 'Hội nghị công khai',
    report_maze: 'Mê cung',
    channel: 'Kênh',
    edit_price: 'Chỉnh sửa giá ($)',
    quantity: 'Số lượng',
    payment_type: 'Hình thức thanh toán',
    total_amount: 'Tổng số tiền ($)',
    net_amount: 'Số tiền thực nhận ($)',
    edit_option: 'Chỉnh sửa tùy chọn',
    marketplace_price: 'Giá thị trường ($)',
    market_name: 'Tên',
    duration_min: 'Thời lượng (phút)',
    users_total: 'Người dùng (tổng)',
    sales_total: 'Tổng doanh thu ($)',
    search_coaching: 'Tìm kiếm huấn luyện',
    search_channel: 'Tìm kiếm kênh',
    search_webinar: 'Tìm kiếm hội thảo trực tuyến',
    search_maze: 'Tìm kiếm mê cung',
    search_public_conference: 'Tìm kiếm hội nghị công khai',
    buyer_type: 'Loại người mua',
    quanity: 'Số lượng',
    channel_unit_amount: 'Số tiền thực nhận ($)',
    channel_updated_at: 'Ngày cập nhật',
    month_price: 'Giá (Hàng tháng)',
    year_price: 'Giá (Hàng năm)',
    one_time_price: 'Giá (Một lần)',
    sharebot_organization: 'Nhập tên tổ chức mới của bạn',
    share_sphere: 'Chia sẻ Quả cầu',
    ai_course_title: 'Tiêu đề khóa học',
    ai_input_course_title: 'Vui lòng nhập tiêu đề khóa học!',
    learning_objective_label: 'Mục tiêu học tập',
    learning_objective_message: 'Vui lòng nhập mục tiêu học tập!',
    standard_question: 'Có tiêu chuẩn nào học viên cần tuân thủ không?',
    standard_details_label: 'Chi tiết tiêu chuẩn',
    standard_details_message: 'Vui lòng nhập chi tiết tiêu chuẩn!',
    estimated_duration_label: 'Thời lượng ước tính (phút)',
    estimated_duration_message: 'Vui lòng nhập thời lượng ước tính!',
    min_duration_message: 'Thời lượng tối thiểu là 5 phút',
    ai_mins: '25 phút',
    industry_specific_question: 'Có liên quan đến ngành cụ thể không?',
    industry_label: 'Tên ngành',
    industry_message: 'Vui lòng nhập tên ngành!',
    ai_course_creation: 'Tạo khóa học bằng AI',
    course_generated: 'Khóa học được tạo bởi Sharelook',
    ai: 'AI',
    ai_you: 'Bạn',
    ai_prompt_ready:
      'Yêu cầu của bạn đã sẵn sàng, bây giờ bạn có thể tạo bản nháp khóa học',
    ai_unable_respond:
      'Xin lỗi! Hiện tại không thể phản hồi yêu cầu của bạn, vui lòng thử lại sau',
    ai_hide_toc: 'Ẩn Mục lục',
    ai_preview_toc: 'Xem trước Mục lục',
    ai_generate_toc_now: 'Tạo Mục lục ngay',
    ai_creation_course_title: 'Tiêu đề khóa học:',
    ai_creation_industry_specific: 'Liên quan đến ngành:',
    ai_creation_industry: 'Ngành:',
    ai_creation_standard_needed: 'Cần tiêu chuẩn:',
    ai_creation_standard_details: 'Chi tiết tiêu chuẩn:',
    ai_creation_estimated_duration: 'Thời lượng ước tính (phút):',
    minutes: 'phút',
    ai_creation_learning_objective: 'Mục tiêu học tập:',
    setup_again: 'Thiết lập lại',
    ai_creation_confirm_title: 'Bạn có chắc muốn thiết lập lại không?',
    ai_creation_confirm_content:
      'Toàn bộ cuộc trò chuyện và nội dung đã tạo sẽ bị xóa',
    ai_toc: 'Mục lục',
    ai_note_topic: 'Lưu ý: Bạn có thể kéo thả các chủ đề',
    ai_add_topic: '+ Thêm Chủ đề',
    add_topic: 'Thêm Chủ đề',
    add_lesson: 'Thêm Bài học',
    add_new_lesson: 'Thêm Bài học Mới',
    ai_add_lesson: '+ Thêm Bài học',
    attention: 'Chú ý',
    before_varifying: 'Trước khi xác minh',
    ai_save_later: 'Lưu để sau',
    ai_download_word_doc: 'Tải xuống tài liệu Word',
    ai_download_course_word_doc: 'Tải khóa học dưới dạng tài liệu Word',
    ai_create_course_button: 'Tạo Khóa học',
    ai_generate_course_content: 'Tạo Nội dung Khóa học',
    ai_out_of: '/',
    ai_subtopic_failed_content:
      'Một số chủ đề phụ không được tạo thành công, vui lòng nhấn nút "Tạo Nội dung Khóa học" lại',
    ai_edit_topic: 'Chỉnh sửa Chủ đề',
    ai_edit_lesson_title: 'Chỉnh sửa Tiêu đề Bài học',
    ai_save_topic: 'Lưu Chủ đề',
    ai_save: 'Lưu',
    ai_save_lesson_title: 'Lưu Tiêu đề Bài học',
    ai_add_new_topic: 'Thêm Chủ đề Mới',
    ai_download_ref: 'Tải xuống có nguồn tham khảo',
    ai_download_ref_content:
      'Khóa học sẽ được tải xuống dưới dạng tài liệu Word bao gồm các nguồn tham khảo',
    ai_download_without_ref: 'Tải xuống không có nguồn',
    ai_download_two_word: 'Tải hai tài liệu Word:',
    ai_download_two_word_content_one: '- Một chứa nội dung (không có nguồn),',
    ai_download_two_word_content_two:
      'cái còn lại chứa nguồn (không có nội dung)',
    ai_manage_content: 'Quản lý Nội dung',
    ai_add_content_from_internet: '+ Thêm Nội dung từ Internet',
    ai_confirm_start: 'Xác nhận Bắt đầu',
    ai_Verify: 'Xác minh',
    ai_undo_warning:
      'Quá trình này có thể mất một chút thời gian, vui lòng không đóng cửa sổ. Hành động này không thể hoàn tác.',
    ai_verified_content:
      'Bạn đã xác minh nội dung, cuộc trò chuyện với AI hiện không khả dụng',
    ai_want_proceed: 'Bạn có chắc muốn tiếp tục không?',
    upload_simulation: 'Tải lên Mô phỏng',
    name_simulation: 'Tên Mô phỏng',
    selected_simulation_files: 'Tệp Mô phỏng đã chọn',
    score_between_one_hundred: 'Điểm phải nằm trong khoảng từ 1 đến 100',
    are_sure_simulation: 'Bạn có chắc muốn xóa tệp mô phỏng này không?',
    required_simulation: 'Yêu cầu điểm',
    required_section_file: 'Yêu cầu tệp phần',
    simulation: 'Mô phỏng',
    simulation_quiz_games: 'Các câu hỏi phải là trò chơi trắc nghiệm',
    simulation_alert_des:
      'Trò chơi có thể được thêm nếu tất cả các câu hỏi là đơn hoặc nhiều lựa chọn',
    alert_info: 'Thông tin',
    ai_number_quiz: 'Số câu hỏi',
    ai_point: 'Điểm',
    ai_points: 'Điểm',
    val_required: 'Bắt buộc',
    games: 'Trò chơi',
    add_simulation: 'Thêm Mô phỏng',
    text_tiewer: 'Trình xem Văn bản',
    back_to_account: 'Quay lại Tài khoản',
    delete_account: 'Xóa Tài khoản',
    delete_account_title: 'Bạn có chắc muốn xóa tài khoản của mình không?',
    delete_account_subtitle: 'Bạn có thể xóa tài khoản của mình tại đây',
    delete_account_cannot_undo:
      'Tài khoản của bạn sẽ bị xóa và hành động này không thể hoàn tác',
    account_org_profile:
      'Tất cả dữ liệu về tài khoản, khóa học và tổ chức sẽ bị xóa',
    deleting_account_database:
      'Sau khi xóa, tất cả dữ liệu sẽ bị loại bỏ khỏi hệ thống',
    account_confirm_delete: 'Bạn có chắc muốn xóa tài khoản của mình không?',
    action_cannot_be_undone: 'Hành động này không thể hoàn tác',
    account_delete_message_success: 'Tài khoản của bạn đã được xóa thành công',
    message_edit: 'Chỉnh sửa',
    message_delete: 'Xóa',
    message_reply: 'Trả lời',
    attached_file: 'Tệp đính kèm',
    attach_file: 'Đính kèm tệp',
    attach_des: 'Tối đa 25 MB',
    view: 'Xem',
    go_to_marketplace: 'Đi đến Chợ',
    learning_center: 'Trung tâm Học tập',
    knowledge_center: 'Trung tâm Kiến thức',
    sharebot: 'ShareBot',
    sharebot_help_message: 'Tôi có thể giúp gì cho bạn hôm nay?',
    my_organization: 'Tổ chức của tôi',
    world_knowledge: 'Kiến thức Thế giới',
    welcome_to_sharelook: 'Chào mừng đến với Sharelook!',
    sharelook_you_want_go: 'Hôm nay bạn muốn đi đâu?',
    shareLook_learning_management_system:
      'Truy cập hệ thống quản lý học tập ShareLook để tạo và tham gia các sự kiện hoặc khóa học trực tiếp',
    shareLook_powerful_ai_system:
      'Tải lên tài liệu PDF và trích xuất nhanh thông tin với hệ thống AI mạnh mẽ của ShareLook, hoặc nhận câu trả lời từ dữ liệu tổ chức hoặc toàn cầu',
    edit_now: 'Chỉnh sửa ngay',
    sharelook_log_out:
      'Phiên đăng nhập Sharelook của bạn đã hết hạn, vui lòng đăng nhập lại!',
    sorry_error: 'Xin lỗi! Đã xảy ra lỗi',
    login: 'Đăng nhập',
    refresh_page: 'Làm mới trang',
    just_a_moment: 'Chờ một chút',
    enter_lname_fname: 'Vui lòng nhập họ và tên để tiếp tục',
    procced_to_sharelook: 'Tiếp tục đến Sharelook',
    option_one: 'Tùy chọn 1',
    option_two: 'Tùy chọn 2',
    selected_image: 'Hình ảnh đã chọn:',
    add_text: 'Thêm văn bản',
    linkdin_is_required: 'LinkedIn là bắt buộc',
    bio_is_required: 'Tiểu sử là bắt buộc',
    save_user_information: 'Lưu thông tin người dùng',
    select_all: 'Chọn tất cả',
    enable_ai: 'Bật AI',
    load_more: 'Tải thêm',
    channel_id: 'ID Kênh',
    send: 'Gửi',
    v4: 'Thông tin',
    subscription: 'Đăng ký',
    reset_user_flag: 'Đặt lại cờ người dùng',
    delete_my_accont: 'Xóa tài khoản của tôi',
    sharebot_sub_error:
      'Lỗi khi truy xuất thông tin đăng ký, vui lòng thử lại!',
    sharebot_no_sub: 'Chưa đăng ký',
    sharebot_dont_sub: 'Không tìm thấy đăng ký trước',
    sharebot_prev_sub: 'Đăng ký trước',
    sharebot_sub: 'Đăng ký ShareBot',
    sharebot_un_sub: 'Hủy đăng ký ShareBot',
    sharebot_no_available: 'Không có dữ liệu',
    sharebot_start_date: 'Ngày bắt đầu:',
    sharebot_end_date: 'Ngày kết thúc:',
    sharebot_sure: 'Bạn có chắc không?',
    sharebot_do_you_want: 'Bạn có muốn:',
    unsubscribe: 'Hủy đăng ký',
    unsubscribe_what: 'Bạn có muốn hủy đăng ký không?',
    subscribe: 'Đăng ký',
    subscribe_what: 'Bạn có muốn đăng ký không?',
    subscribe_now: 'Đăng ký ngay',
    confirm: 'Xác nhận',
    sharebot_intel_knowledge_center: 'Trung tâm Kiến thức ShareBot',
    sharebot_welcome_paragraph:
      'Chào mừng bạn đến Trung tâm Kiến thức ShareBot. Đây là trợ lý AI của bạn, được thiết kế để giúp các chuyên gia truy cập nhanh thông tin.',
    expired: 'Hết hạn',
    active: 'Hoạt động',
    Inactive: 'Không hoạt động',
    yearly_subscription: 'Đăng ký hàng năm',
    monthly_subscription: 'Gói đăng ký hàng tháng',
    no_sharebot_org: 'Bạn không có tổ chức ShareBot nào',
    sharebot_start_free_trial: 'Bắt đầu dùng thử miễn phí',
    sub_month: 'Đăng ký hàng tháng',
    sub_year: 'Đăng ký hàng năm',
    question_per_month: 'Lưu trữ dữ liệu (1TB) và 1000 câu hỏi mỗi tháng',
    sharebot_para:
      'Khi tiếp tục, bạn xác nhận xóa tổ chức ngay lập tức. Hành động này sẽ dẫn đến mất tất cả các thông tin quý giá do ShareBot cung cấp và không thể hoàn tác.',
    cancelled_date: 'Ngày hủy:',
    live_straming_para:
      'Nếu bạn muốn thay đổi giới hạn phát trực tiếp hàng tháng, vui lòng liên hệ',
    sharelook_agree: 'Tôi đồng ý với',
    terms_condition: 'điều khoản & điều kiện',
    and: 'và',
    privacy_policy: 'chính sách bảo mật',
    save_for_later: 'Lưu để sau',
    ai: 'AI',
    no_video_yet: 'Chưa chọn video nào!',
    are_you_sure_delete_video: 'Bạn có chắc chắn muốn xóa video này không?',
    video_des: 'Mô tả',
    video_now: 'Bây giờ',
    video_playing: 'Đang phát:',
    video_no: 'Video số',
    ai_generated_course: 'Khóa học được tạo bằng AI',
    create_course_on_our_own: 'Tự tạo khóa học',
    ai_Assisted_ourse_reation: 'Tạo khóa học với sự hỗ trợ của AI',
    pending: 'Đang chờ',
    published: 'Đã xuất bản',
    intro_course: 'vào khóa học của bạn?',
    clone_course: 'Bạn có muốn sao chép',
    browser_audio_not_support: 'Trình duyệt của bạn không hỗ trợ thẻ âm thanh.',
    audio_popup_content:
      'Bạn có thể sử dụng nhiều kiểu giọng nói khác nhau cho văn bản bạn gõ vào. Bla bla bla Lorem Ipsum chỉ là văn bản mẫu của ngành in ấn và sắp chữ.',
    close: 'Đóng',
    podcast_rec: 'GHI',
    create_podcast: 'Tạo Podcast',
    add_admin: 'THÊM QUẢN TRỊ VIÊN',
    delete_all: 'Xóa tất cả',
    ai_podcast_audio: 'Âm thanh Podcast AI',
    language: 'Ngôn ngữ',
    podcast_download_content:
      '*Tải xuống tệp âm thanh AI để chỉnh sửa và trở thành tệp âm thanh của bạn.',
    upload_audio: 'Tải âm thanh lên',
    browser_do_not_support_audio:
      'Trình duyệt của bạn không hỗ trợ phần tử âm thanh.',
    upload_cover: 'Tải ảnh bìa lên',
    upload_ai_creator: 'Trình tạo AI',
    required_cover_image: 'Ảnh bìa là bắt buộc!',
    room_required_name: 'Tên podcast là bắt buộc!',
    add_guest_list: 'Vui lòng thêm danh sách khách mời!',
    podcast_add_participants: 'THÊM NGƯỜI THAM GIA',
    topic_required: 'Cần ít nhất một chủ đề',
    podcast_description: 'MÔ TẢ',
    podcast_date: 'NGÀY',
    date: 'Ngày',
    podcast_time: 'thời gian',
    podcast_to: 'đến',
    podcast_all_day: 'Cả ngày',
    podcast_start_date_time: 'Yêu cầu ngày bắt đầu và khoảng thời gian!',
    podcast_id: 'ID',
    selected_user: 'Mời người dùng đã chọn',
    see_more: 'Xem thêm',
    see_less: 'Ẩn bớt',
    no_review_yet: 'Chưa có đánh giá nào, hãy là người đầu tiên.',
    request_to_speak: 'Chấp nhận yêu cầu phát biểu của người dùng?',
    kick_user: 'Bạn có muốn loại người dùng này không?',
    accept_request: 'Chấp nhận yêu cầu',
    kick: 'LOẠI',
    started: 'ĐÃ BẮT ĐẦU',
    end: 'KẾT THÚC',
    join_now: 'Tham gia ngay',
    podcast_end: 'Podcast đã kết thúc',
    connecting: 'đang kết nối...',
    knowledge_center_know_today: 'Hôm nay bạn muốn biết điều gì?',
    knowledge_center_question: 'Vui lòng nhập câu hỏi trước',
    knowledge_center_error: 'Rất tiếc! Đã xảy ra lỗi.',
    knowledge_center_tooltrip:
      'Nhận câu trả lời nhanh từ tài liệu học tập trong kho lưu trữ của tổ chức bạn trên ShareLook, với tài liệu tham khảo rõ ràng và khả năng xem trước/tải xuống tài liệu PDF.',
    my_organization: 'Tổ chức của tôi',
    world_knowledge: 'Kiến thức thế giới',
    open_file: 'Mở tập tin',
    reference: 'Tham khảo',
    are_you_cancel: 'Bạn có chắc muốn hủy không?',
    are_you_remove_media: 'Bạn có chắc muốn xóa phương tiện này không?',
    terms_agree: 'Tôi đồng ý với những',
    ready: 'Sẵn sàng',
    send_email: 'GỬI EMAIL',
    active_users: 'Người dùng đang hoạt động',
    sign_up_user: 'Người dùng đã đăng ký',
    non_sign_up_user: 'Người dùng chưa đăng ký',
    organisation: 'Tổ chức',
    usage_report: 'Báo cáo sử dụng',
    check_email: 'kiểm tra email của bạn',
    delete_schedule: 'Xóa lịch trình',
    are_you_sure_delete_schedule:
      'Bạn có chắc chắn muốn xóa lịch trình này không?',
    add_task: 'Vui lòng nhập một nhiệm vụ!',
    coaching_available: 'Đánh dấu là có sẵn để huấn luyện',
    message_booking_coaching:
      'Khoảng thời gian này đã được người dùng đặt để huấn luyện.',
    task_day: 'Ngày có nhiệm vụ',
    created_task_day: 'Bạn đã tạo một nhiệm vụ cho ngày này.',
    event_day: 'Ngày diễn ra sự kiện',
    has_booked_coaching: 'Đã có buổi huấn luyện được đặt vào ngày này.',
    active_day: 'Ngày đang hoạt động',
    selectable_time_slots:
      'Các khung giờ có thể chọn ở bên phải đang hoạt động cho ngày này.',
    compare_last_month: 'So với tháng trước',
    uploading_file: 'Đang tải tệp của bạn lên',
    attach_file_course: 'đã đính kèm vào khóa học này.',
    fetch_request: 'Đang xử lý yêu cầu của bạn',
    finilize_upload: 'Đang hoàn tất tải lên',
    scorm_scanned: 'Vui lòng đợi... SCORM zip của bạn đang được quét.',
    scan_status: 'Trạng thái quét:',
    scan_completed: 'Đã quét xong. Tệp của bạn là',
    scan_progress: 'Đang quét...',
    check_scorm: 'Đang kiểm tra định dạng tệp SCORM... Vui lòng đợi...',
    file_check_success: 'Kiểm tra tệp thành công',
    file_check_progress: 'Đang kiểm tra tệp...',
    scorm_not_upload:
      'Tệp bạn tải lên không phải chuẩn SCORM 1.2. Vui lòng tải lại tệp.',
    select_question: 'Tùy chọn trả lời (chọn một câu trả lời đúng)',
    select_answer: 'Vui lòng chọn một câu trả lời!',
    check_option_one: 'Vui lòng nhập tùy chọn một!',
    check_option_two: 'Vui lòng nhập tùy chọn hai!',
    check_option_three: 'Vui lòng nhập tùy chọn ba!',
    check_option_four: 'Vui lòng nhập tùy chọn bốn!',
    question_image: 'Hình ảnh câu hỏi',
    select_question_image: 'Vui lòng chọn hình ảnh câu hỏi!',
    ans_image: 'Hình ảnh câu trả lời',
    upload_image_question: 'Tải hình ảnh câu trả lời',
    select_image_answer: 'Vui lòng chọn hình ảnh câu trả lời!',
    save_question: 'Lưu câu hỏi',
    do_you_leave: 'Bạn có chắc muốn rời đi?',
    loose_all_progress: 'Bạn sẽ mất tất cả tiến trình.',
    welcome: 'Chào mừng',
    team_knowledge_quest: 'Cuộc thi kiến thức nhóm',
    your_score: 'Điểm số của bạn',
    start_playing: 'Bắt đầu chơi',
    share_sphere_complete: 'Hoàn thành ShareSphere',
    final_score: 'Điểm số cuối cùng',
    play_next: 'Chơi tiếp',
    you_donot_access_event: 'Bạn không có quyền truy cập sự kiện này.',
    ai_content_generated: 'Nội dung đã được tạo cho chủ đề này.',
    ai_popup_confirm_content: 'Xác nhận tạo nội dung',
    limit_transcribe_text:
      'Thời gian phiên âm còn lại: <0>{{ transcribe_limit }}</0> phút <1/><2/> <3>. Để thay đổi giới hạn phiên âm, vui lòng liên hệ </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'Bạn không có quyền truy cập sự kiện này.',
    ai_course_title_training: 'Khóa đào tạo kỹ năng lãnh đạo',
    ai_course_object: 'Điều hướng lãnh đạo trong thời đại số',
    create_ai_video: 'Tạo video AI',
    generate: 'TẠO',
    video_generate_process:
      'Quá trình tạo video có thể mất một chút thời gian. Bạn sẽ nhận được email khi hoàn tất.',
    stripe_account_connect:
      'Tài khoản Stripe của bạn chưa được kích hoạt. Vui lòng kết nối hoặc kích hoạt để tiếp tục.',
    ai_creator: 'Công cụ tạo AI',
    check_video_status: 'Đang kiểm tra trạng thái tạo video...',
    video_on_queue: 'Video đang trong hàng chờ xử lý.',
    video_fail_generation:
      'Rất tiếc, quá trình tạo video thất bại. Vui lòng thử một video khác.',
    video_currently_generated: 'Video này hiện đang được tạo.',
    checking_status: 'Đang kiểm tra trạng thái',
    check_status: 'Kiểm tra trạng thái',
    browser_does_not_support_audio:
      'Trình duyệt của bạn không hỗ trợ thẻ audio',
    existing_edit_scenario:
      'Bạn muốn chỉnh sửa kịch bản hiện tại hay tạo mới? Nếu bạn tạo mới, kịch bản cũ sẽ bị mất.',
    generate_scenario: 'Tạo kịch bản',
    layout: 'Bố cục',
    confirm_change: 'Xác nhận thay đổi',
    generated_ai_creation_message:
      'Lưu ý: Chỉ những thành phần văn bản được tạo bởi AI sẽ được giữ lại. Tất cả các thành phần khác sẽ bị xóa khỏi trang.',
    generate_story: 'Tạo câu chuyện',
    save_original_content: 'Lưu nội dung gốc:',
    story_added_specified_position:
      'Vị trí của câu chuyện trong bài học. Câu chuyện sẽ được thêm vào dưới dạng một khối ở vị trí được chỉ định.',
    position_of_story: 'Vị trí của câu chuyện',
    start_the_lesson: 'Bắt đầu bài học',
    end_the_lesson: 'Kết thúc bài học',
    add_story_pages: 'Thêm câu chuyện vào các trang',
    browser_does_not_support:
      'Trình duyệt của bạn không hỗ trợ phần tử âm thanh.',
    no_video_available: 'Không có video nào khả dụng.',
    no_podcast_available: 'Không có podcast nào khả dụng.',
    no_item_baskets: 'Không có sản phẩm nào trong giỏ hàng.',
    ai_course_object: 'Điều hướng lãnh đạo trong thời đại số'
  },
  v2: {
    n_data: 'Không có dữ liệu',
    change: 'Thay đổi',
    remove: 'Xóa',
    auto_background: 'Nền tự động',
    create_new_course_org: 'Tạo khóa học mới cho tổ chức của bạn.',
    create_new_course_marketplace: 'Tạo khóa học mới cho thị trường.',
    create_new_course_both: 'Tạo khóa học mới cho cả tổ chức và thị trường.',
    ok: 'Đồng ý',
    page_bg: 'Nền trang',
    lesson_cover: 'Ảnh bìa bài học',
    create_skill_journey: 'Tạo Hành trình Kỹ năng',
    Metamaze: 'Metamaze',
    events: 'Sự kiện',
    scroms: 'SCORMs',
    min_score_pass: 'Điểm tối thiểu để đạt',
    no_scorms_available: 'Không có SCORM nào khả dụng.',
    no_events_available: 'Không có sự kiện nào khả dụng.',
    no_courses_available: 'Không có khóa học nào khả dụng.',
    no_courses_baskets: 'Không có khóa học trong giỏ hàng.',
    no_mazes_baskets: 'Không có mê cung trong giỏ hàng.',
    no_scroms_baskets: 'Không có SCORM trong giỏ hàng.',
    no_events_baskets: 'Không có sự kiện trong giỏ hàng.',
    sorry: 'Xin lỗi!',
    option_1: 'Lựa chọn 1',
    option_2: 'Lựa chọn 2',
    enter_number_words: 'Nhập số từ tối đa.',
    summarize: 'Tóm tắt',
    answer: 'Trả lời',
    hold_tight_one_minute:
      'Chờ một chút! Chúng tôi vẫn đang chuẩn bị. Điều này có thể mất đến một phút.',
    enter_question: 'Nhập câu hỏi của bạn.',
    enter_relevant_documents: 'Nhập số lượng tài liệu liên quan.',
    please_input_relevant_documents:
      'Vui lòng nhập số lượng tài liệu liên quan!',
    please_wait_loading_results: 'Vui lòng đợi tải kết quả...',
    proceed_to_add_voice: 'Tiếp tục thêm giọng nói',
    results: 'Kết quả',
    no_result_found_try_asking_questions:
      'Không tìm thấy kết quả. Hãy thử hỏi thêm câu hỏi.',
    eg: 'ví dụ,',
    what_make_sales_manager:
      'Điều gì có thể khiến tôi trở thành quản lý bán hàng?',
    please_select_lang: 'Vui lòng chọn ngôn ngữ!',
    search: 'Tìm kiếm',
    please_copy_desired_content:
      'Vui lòng sao chép nội dung mong muốn từ hộp bên trái sang hộp bên phải.',
    rating_req: 'Xếp hạng là trường bắt buộc.',
    review_req: 'Đánh giá là trường bắt buộc.',
    rating_review_req: 'Phải cung cấp cả xếp hạng và đánh giá.',
    how_rate_this: 'Bạn sẽ đánh giá điều này như thế nào?',
    amazing_above_expectations: 'Tuyệt vời! Vượt ngoài mong đợi!',
    certificates: 'Chứng chỉ',
    you_no_certificates: 'Bạn hiện không có chứng chỉ nào.',
    please_add_review:
      'Vui lòng cung cấp đánh giá cùng với xếp hạng, cảm ơn bạn!',
    post: 'Đăng',
    rate: 'Đánh giá',
    avg_rating: 'Xếp hạng trung bình',
    no_review_found: 'Không tìm thấy đánh giá',
    are_sure_to_disale_zoom_integration:
      'Bạn có chắc chắn muốn vô hiệu hóa tích hợp Zoom không?',
    badges: 'Huy hiệu',
    you_no_badge_available: 'Bạn hiện không có huy hiệu nào.',
    download_certificate: 'Tải chứng chỉ',
    loading: 'Đang tải...',
    no_file_attached: 'Không có tệp đính kèm',
    you_do_not_have_any_notes: 'Bạn không có ghi chú nào.',
    question: 'Câu hỏi',
    score: 'Điểm',
    alert_score_message: 'Người(được) đã gửi điểm của họ.',
    alert_question_message: 'Chưa có câu hỏi nào được thêm vào.',
    button_submit: 'Gửi',
    button_allScores: 'Tất cả điểm đã được gửi.',
    record_wait: 'Bắt đầu ghi âm. Vui lòng đợi...',
    buttonSubmit_warning: 'Vui lòng nhập tất cả điểm trước khi gửi.',
    upload_ar_assets: 'Tải lên tài sản AR',
    edit_ar_assets: 'Chỉnh sửa tài sản AR',
    edit_maze_assets: 'Chỉnh sửa tài sản MetaMaze',
    upload_assets: 'Tải lên tài sản',
    upload_maze_assets: 'Tải lên tài sản MetaMaze',
    trigger_title: 'Tiêu đề kích hoạt',
    model_title: 'Tiêu đề mô hình',
    trigger_description: 'Mô tả kích hoạt',
    model_description: 'Mô tả mô hình',
    please_type_target_description: 'Vui lòng nhập mô tả mục tiêu.',
    please_type_model_description: 'Vui lòng nhập mô tả mô hình.',
    trigger_image: 'Ảnh kích hoạt*',
    model_image: 'Ảnh mô hình*',
    upload_trigger_image: 'Tải lên ảnh kích hoạt',
    upload_model_image: 'Tải lên ảnh mô hình',
    drag_n_drop: 'Kéo và thả',
    file_size_should_not_exceed:
      '(Kích thước tập tin ảnh (JPEG) không được vượt quá 512 KB)',
    zip_size_should_not_exceed: '(Kích thước tập tin nén không vượt quá 60 MB)',
    ar_content: 'Nội dung AR*',
    model_content: 'Mô hình 3D*',
    upload_3d_zip: 'Tải lên ZIP / Video',
    upload_3d_maze_zip: 'Tải lên ZIP',
    audio_content: 'Nội dung âm thanh',
    _mp3: '(.mp3)',
    content_attached: 'Tập tin nén đã được đính kèm.',
    video_attached: 'Video đã được đính kèm.',
    audio_attached: 'Âm thanh đã được đính kèm.',
    enter_trigger_image_title: 'Nhập tiêu đề ảnh kích hoạt.',
    enter_model_title: 'Nhập tiêu đề mô hình MetaMaze.',
    ar_preview_image: 'Ảnh xem trước AR',
    upload_preview_image: 'Tải lên ảnh xem trước',
    upload_audio: 'Tải lên âm thanh',
    creating___: 'Đang tạo...',
    updating___: 'Đang cập nhật...',
    create: 'Tạo',
    update: 'Cập nhật',
    ar_assets: 'Ảnh 3D',
    _3d_files_mp4: '(Tập tin .obj, .fbx hoặc video .mp4 nén)',
    _3d_files_mp4_ar: '(Tập tin .obj, .fbx nén)',
    maze_3d_files_mp4: '(Tập tin .obj, .fbx nén)',
    _jpg_files: 'Chỉ hỗ trợ .jpg',
    persons_have_submitted_their_scores: 'Đã có người gửi điểm của họ.',
    no_questions_added_till_now: 'Chưa có câu hỏi nào được thêm.',
    submit: 'Gửi',
    all_scores_submitted: 'Tất cả điểm đã được gửi.',
    recording_is_starting: 'Bắt đầu ghi âm, vui lòng đợi...',
    please_input_scores_before_submitting:
      'Vui lòng nhập tất cả điểm trước khi gửi.',
    end_for_all: 'Kết thúc cho tất cả',
    full_screen: 'Toàn màn hình',
    breakout_room: 'Phòng nhóm nhỏ',
    send_invitations: 'Gửi lời mời',
    add_participants: 'Thêm người tham gia',
    create_breakout_room: 'Tạo phòng nhóm nhỏ',
    connecting: 'Đang kết nối...',
    currently_broadcaster_unavailable: 'Người phát sóng hiện không khả dụng.',
    how_many_breakout_room_to_create: 'Bạn muốn tạo bao nhiêu phòng nhóm nhỏ?',
    create_upto_three_breakout_rooms: '*Tạo tối đa 3 phòng nhóm nhỏ',
    allow: 'Cho phép',
    additional: 'Bổ sung',
    attachment: 'Tệp đính kèm',
    no_description_available: 'Không có mô tả.',
    people: 'NGƯỜI',
    waiting: 'Đang chờ',
    hand_raising_users: 'Người giơ tay',
    invite: 'Mời',
    create_room: 'Tạo phòng',
    create_live_event: 'Tạo sự kiện trực tiếp',
    support_upto_fivethousand_participants:
      'Hỗ trợ tối đa 5.000 người tham gia sự kiện',
    support_upto_ten_participants:
      'Hỗ trợ tối đa 10 người tham gia video trực tiếp',
    support_upto_twohundred_participants:
      'Hỗ trợ tối đa 200 người tham gia sự kiện',
    supprt_upto_five_participants:
      'Hỗ trợ tối đa 5 người tham gia video trực tiếp',
    support_upto_twentyfive_participants:
      'Hỗ trợ tối đa 25 người tham gia video trực tiếp cho sự kiện',
    two_live_video_participants:
      'Có 2 người tham gia video trực tiếp trong sự kiện (người dẫn chương trình và người tham gia)',
    you_can_have_upto_five_examinees: 'Bạn có thể có tối đa 5 thí sinh.',
    you_can_have_upto_twentyfive_participants:
      'Bạn có thể có tối đa 25 người tham gia.',
    you_can_have_upto_five_participants:
      'Bạn có thể có tối đa 5 người tham gia.',
    you_can_have_upto_ten_participants:
      'Bạn có thể có tối đa 10 người tham gia.',
    select_hosts_email: 'Chọn email người dẫn chương trình',
    send_invite_email: 'Gửi email mời',
    do_not_send_invite_email: 'Không gửi email mời',
    error: 'Lỗi',
    max_twentyfive_users_allowed: 'Cho phép tối đa 25 người dùng được chọn',
    max_five_users_allowed: 'Cho phép tối đa 5 người dùng được chọn',
    max_ten_users_allowed: 'Cho phép tối đa 10 người dùng được chọn',
    no_user_found: 'Không tìm thấy người dùng',
    transcribe_to: 'Chuyển thành',
    integrate_zoom_to_start_meeting:
      'Tích hợp Zoom vào tài khoản của bạn để bắt đầu cuộc họp Zoom.',
    zoom_is_not_integrated: 'Zoom chưa được tích hợp.',
    delete_poll: 'Xóa cuộc thăm dò',
    add_poll: 'Thêm cuộc thăm dò',
    live_now: 'ĐANG TRỰC TIẾP!',
    average_rating: 'Đánh giá trung bình',
    review: 'Đánh giá',
    time_spent: 'Thời gian đã dùng',
    total: 'Tổng',
    mins: 'Phút',
    no_data: 'Không có dữ liệu cho bài kiểm tra này.',
    total_score: 'Tổng điểm',
    pass_score: 'Điểm đạt',
    point: 'Điểm',
    wrong: 'Sai',
    response: 'Phản hồi',
    submitted: 'Đã nộp',
    average: 'Trung bình',
    total_play: 'Tổng số lần chơi',
    view_graph: 'Xem biểu đồ',
    time_spent_mins: 'Thời gian đã dùng (phút)',
    play: 'Chơi',
    ideal_path: 'Lộ trình lý tưởng',
    user_incorrect_path: 'Lộ trình sai của người dùng',
    ideal_path_taken: 'Lộ trình lý tưởng người dùng đã đi',
    scenario: 'Kịch bản',
    option: 'Lựa chọn',
    spend: 'Thời gian tiêu tốn',
    average_spending_time: 'Thời gian tiêu tốn trung bình',
    activity_overview: 'Tổng quan hoạt động',
    live_event: 'Sự kiện trực tiếp',
    live_assessment: 'Đánh giá trực tiếp',
    report_download: 'Tải báo cáo',
    all_workshops: 'Tất cả hội thảo',
    overview_average_activity: 'Tổng quan hoạt động trung bình',
    overview_workshop_graph: 'Biểu đồ tổng quan hội thảo',
    mazes: 'Mê cung',
    correct_feedback: 'Phản hồi đúng',
    incorrect_feedback: 'Phản hồi sai',
    checkin_checkout: 'Điểm danh - Thanh toán',
    minutes: 'Phút',
    incorrect_path: 'Lộ trình sai',
    answer_not_available: 'Không có câu trả lời',
    views: 'Lượt xem',
    item: 'Mục',
    questions: 'Câu hỏi',
    total_points: 'Tổng điểm',
    total_attempts: 'Tổng số lần thử',
    created_date: 'Ngày tạo',
    host_name: 'Tên người dẫn',
    host_section: 'Phần người dẫn',
    choose_products: 'Chọn sản phẩm',
    add_to_basket: 'Thêm vào giỏ',
    basket: 'Giỏ hàng',
    times: 'Lần',
    scorms: 'SCORMs',
    skill_journey_overview: 'Tổng quan hành trình kỹ năng',
    how_to_use: 'Cách sử dụng',
    live_broadcast_description:
      'CHÚNG TÔI ĐÃ TÍCH HỢP VIDEO TRỰC TIẾP VÀO TRÌNH XÂY DỰNG KHÓA HỌC DỄ SỬ DỤNG',
    live_broadcast_subdescription:
      'Với hệ thống phát sóng trực tiếp đã được cấp bằng sáng chế của ShareLook, bạn có thể tạo sự tương tác, tự động hóa việc học và tối đa hóa chia sẻ kiến thức.',
    disclaimer: `Tôi cam đoan hành trình kỹ năng của tôi sẽ không:
  - vi phạm quyền của bất kỳ bên thứ ba nào
  - chứa bất kỳ nội dung bất hợp pháp nào, bao gồm phỉ báng, tục tĩu, khiếm nhã, khiêu dâm, bạo lực, lăng mạ, xúc phạm, đe dọa hoặc phân biệt đối xử, ngay cả khi được ngụy trang bằng dấu sao
  - chứa bất kỳ cuộc tấn công cá nhân nào đối với người khác
  - giả mạo người tham gia khác, nhân vật công chúng hoặc người nổi tiếng
  - chứa bất kỳ bản ghi âm hoặc thông tin cá nhân nào về bất kỳ cá nhân nào mà không có sự đồng ý của họ và không vi phạm bất kỳ quy định bảo vệ dữ liệu nào ở bất kỳ nơi nào trên thế giới
  - chứa bất kỳ lời mời thương mại hoặc bất kỳ hình thức “spam” nào`,
    price: 'Giá',
    video_link: 'Liên kết video',
    category: 'Danh mục',
    objectives: 'Mục tiêu',
    marketplace_description: 'Mô tả thị trường',

    live_discussion: 'THẢO LUẬN TRỰC TIẾP',
    poll: 'BỎ PHIẾU',
    hide_grid: 'Ẩn lưới',
    show_grid: 'Hiện lưới',
    stop_screen_share: 'Dừng chia sẻ màn hình',
    screen_share: 'Chia sẻ màn hình',
    mute: 'Tắt tiếng',
    unmute: 'Bật tiếng',
    raise_hand: 'Giơ tay',
    waiting__: 'Đang chờ...',
    audio_active: 'Âm thanh đang hoạt động'
  },
  general: {
    save: 'Lưu',
    autosaved: 'đã lưu tự động',
    back_to: 'Quay về',
    by: 'bởi',
    chat: 'Trò chuyện',
    completed: 'Đã hoàn thành',
    canceled: 'Đã hủy',
    component: 'Thành phần',
    confirm: 'Xác nhận',
    course: 'Khóa học',
    skill: 'Hành Trình Kỹ Năng',
    maze: 'MetaMaze',
    channel: 'Kênh',
    podcast: 'Podcast',

    date: 'Ngày',
    details: 'Thông tin chi tiết',
    empty: 'Không có dữ liệu',
    enrolled: 'Đã ghi danh',
    free: 'Miễn phí',
    graph: 'Biểu đồ',
    loading: 'Đang tải...',
    lesson: 'Bài học',
    lessons: 'Bài học',
    live_assessment: 'Đánh giá trực tiếp',
    live_event: 'Sự kiện trực tiếp',
    no: 'Không',
    of: 'Của',
    or: 'Hoặc',
    organization: 'Tổ chức',
    page: 'Trang',
    pages: 'Trang',
    personal: 'Cá nhân',
    poll: 'Thăm dò ý kiến',
    rating: 'Điểm đánh giá',
    reset: 'Đặt lại',
    signin: 'Đăng nhập',
    signup: 'Đăng ký',
    soon: 'Sắp có',
    type: 'Loại',
    uploading: 'Đang tải lên...',
    yes: 'Đồng ý',
    something_went_wrong: 'Có lỗi phát sinh!',
    view_all: 'Xem toàn bộ',
    upload_successful: 'Tải lên thành công',
    upload_successful_message:
      'Các tệp excel của bạn đã được tải lên thành công và hiện đang được xử lý. Việc này có thể mất chút thời gian.',
    check_email_upload_successful:
      'Vui lòng <0>kiểm tra email của bạn</0> để xem <1>báo cáo</1> về danh sách người dùng đã tải lên.',
    is_private: 'Riêng tư'
  },

  account: {
    title: 'Tài khoản',
    subtitle: 'Quản lý cài đặt và thông tin tài khoản của bạn.',
    saved: 'Tài khoản đã được thay đổi'
  },

  assessments: {
    title: 'Bài đánh giá',
    subtitle: 'Tạo Bài đánh giá',
    finished: 'Bài đánh giá đã kết thúc',
    countdown: 'Buổi đánh giá trực tiếp sẽ được phát sóng sau ',
    create: 'Tạo bài đánh giá',
    list_title: 'Bài đánh giá của bạn',
    delete_warning: 'Bạn có chắc chắn muốn xóa mục này không?',
    details_title: 'Thêm thông tin về bài đánh giá',
    details_subtitle:
      'Đặt tên cho Bài đánh giá của bạn và cho biết người xem sẽ học được gì từ nó.',
    disclaimer: `Tôi bảo đảm rằng bài đánh giá được ghi lại của tôi sẽ không:     - vi phạm quyền của bên thứ ba bất kỳ
    - chứa nội dung bất hợp pháp bất kỳ, bao gồm nội dung mang tính phỉ báng, tục tĩu, khiếm nhã, dâm ô, khiêu dâm, bạo lực, lạm dụng, lăng mạ, đe dọa hoặc phân biệt đối xử, kể cả nội dung đã được che bằng dấu hoa thị
    - mang tính công kích cá nhân đối với những người khác
    - chứa hành vi mạo danh người tham gia khác, giả dạng nhân vật của công chúng hoặc người nổi tiếng
    - chứa bản ghi hoặc thông tin cá nhân về một cá nhân bất kỳ mà không có sự đồng ý của cá nhân đó hoặc vi phạm các quy định bảo vệ dữ liệu ở bất kỳ nơi nào trên thế giới
    - chứa lời mời chào thương mại hoặc bất kỳ hình thức "spam" nào`,
    assessment_details: 'Chi tiết Bài đánh giá',

    assessment_settings: 'Cài đặt Bài đánh giá'
  },

  buildersettings: {
    title: 'Cài đặt Đăng tải',
    subtitle:
      'Thêm các thiết lập cho sự kiện của bạn, đối tượng nào có thể xem và tương tác với sự kiện này'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Thêm',
    add_page: 'Thêm trang',
    add_lesson: 'Thêm bài học',
    add_answer: 'Thêm câu trả lời mới',
    add_group: 'Thêm nhóm',
    add_organization: 'Thêm tổ chức',
    add_question: 'Thêm câu hỏi',
    add_quiz: 'Thêm bài kiểm tra',
    add_users: 'Thêm người dùng',
    back: 'Quay lại',
    back_to_course: 'Quay lại trang Tổng quan về khóa học',
    back_to_lesson: 'Quay lại trang Tổng quan về bài học',
    back_to_media: 'Quay lại Thư viện tệp tin',
    back_to_details: 'Quay lại trang thông tin chi tiết',
    cancel: 'Hủy',
    clear: 'Xóa',
    close: 'Đóng',
    clone: 'Sao chép',
    close_lesson: 'Đóng bài học',
    clone_course: 'Sao chép Khóa học',
    confirm: 'Xác nhận',
    create: 'Tạo',
    download: 'Tải về',
    download_mass_user_tamplate: 'Tải xuống Mẫu',
    add_mass_users: 'Thêm người dùng hàng loạt',
    upload_excel_list: 'Tải lên danh sách Excel',
    delete: 'Xóa tệp',
    edit: 'Sửa',
    edit_course: 'Sửa khóa học',
    enroll: 'Ghi danh',
    finish: 'Hoàn thành',
    upload_image: 'Tải ảnh lên',
    upload_image_video: 'Tải lên hình ảnh hoặc video',
    select_media_library: 'Chọn thư viện tệp tin',
    make_public: 'Đặt ở chế độ công khai',
    make_private: 'Đặt ở chế độ riêng tư',
    make_org: 'Đặt ở chế độ dành cho tổ chức',
    media: 'Thư viện tệp tin',
    my_theme: 'Giao diện của tôi',
    next: 'Tiếp',
    next_lesson: 'Bài học tiếp theo',
    next_step: 'Bước tiếp theo',
    previous_step: 'Bước trước đó',
    publish: 'Đăng tải',
    publish_assessment: 'Đăng tải Bài đánh giá của bạn',
    publish_course: 'Đăng tải Khóa học của bạn',
    publish_event: 'Đăng tải Sự kiện của bạn',
    reset: 'Đặt lại',
    reset_elements: 'Thiết lập lại các yếu tố',
    save: 'Lưu',
    creating: 'Đang tạo...',
    updating: 'Đang cập nhật...',
    saved: 'Đã lưu',
    save_for_later: 'Lưu lại để sau',
    save_settings: 'Lưu cài đặt',
    select_files: 'Chọn tệp tin',
    select_theme: 'Lựa chọn giao diện',
    start_lesson: 'Bắt đầu bài học',
    update: 'Cập nhật',
    upload: 'Tải lên',
    upload_audio: 'Tải lên âm thanh',
    upload_photo: 'Tải lên ảnh hồ sơ',
    upload_video: 'Tải video lên',
    enrolled: 'Đã ghi danh',
    unenroll: 'Hủy đăng ký',
    from_library: 'Thư viện tệp tin',
    remove: 'Xóa',
    removed: 'Đã xóa',
    start_broadcast: 'Bắt đầu phát sóng',
    end_broadcast: 'Kết thúc phát sóng',
    camera: 'Camera',
    screen: 'Màn hình',
    screen_with_camera: 'Màn hình có Camera',
    insert: 'Chèn',

    inserting: 'Đang chèn'
  },

  card: {
    quick_add: 'Thêm nhanh',
    add: 'Thêm',
    clone: 'Sao chép',
    completed: 'Hoàn tất bài học'
  },

  course: {
    upcoming_course: 'Khóa học sắp tới',
    unPublishEvent: 'Hủy đăng tải Sự kiện',
    unPublishAssessment: 'Hủy đăng tải Bài đánh giá',
    pastCourse: 'Khóa đào tạo',
    upcoming: 'Sự kiện trực tiếp sắp diễn ra',
    pastEvent: 'Sự kiện trực tiếp từng diễn ra',
    pastAssessment: 'Bài đánh giá trực tiếp từng diễn ra',
    upcomingAssessment: 'Bài đánh giá trực tiếp sắp diễn ra',
    created: 'Ngày tạo:',
    assignees: 'Người được giao',
    organisations:
      ' {{ organizations }} Tổ chức, <2> {{ users }} người dùng</2>',
    event_date: 'Ngày diễn ra sự kiện trực tiếp <1> {{ date }} </1>',
    delete_warning: 'Bạn chắc chắn muốn xóa chứ?',
    clonning_no_lesson:
      'Nếu bạn muốn sao chép Khóa học này, vui lòng thêm ít nhất một Bài học.',
    clone_warning: 'Bạn chắc chắn muốn sao chép mục này chứ?',
    clone_success: 'đang trong quá trình sao chép',
    disclaimer: `Tôi bảo đảm rằng khóa học của tôi sẽ không:     - vi phạm quyền của bên thứ ba bất kỳ
    - chứa nội dung bất hợp pháp bất kỳ, bao gồm nội dung mang tính phỉ báng, tục tĩu, khiếm nhã, dâm ô, khiêu dâm, bạo lực, lạm dụng, lăng mạ, đe dọa hoặc phân biệt đối xử, kể cả nội dung đã được che bằng dấu hoa thị
    - mang tính công kích cá nhân đối với những người khác
    - chứa hành vi mạo danh người tham gia khác, giả dạng nhân vật của công chúng hoặc người nổi tiếng
    - chứa thông tin cá nhân về một đối tượng bất kỳ mà không có sự đồng ý của cá nhân đó hoặc vi phạm các quy định bảo vệ dữ liệu ở bất kỳ nơi nào trên thế giới
    - chứa lời mời chào thương mại hoặc bất kỳ hình thức "spam" nào`
  },

  coursecreate: {
    dropzone_text: 'Chèn tệp',
    sidebar_text: 'Chọn giao diện chủ đề <1/> cho <3/> bài học của bạn',
    delete_warning: 'Bạn có chắc muốn xóa bài học này không?'
  },

  coursepage: {
    quizview_loading: 'Đang kiểm tra câu trả lời. Vui lòng đợi...',
    quizview_answer: 'Câu trả lời của bạn'
  },

  coursequiz: {
    title: 'Bài kiểm tra của toàn bộ Bài học'
  },

  dashboard: {
    tooltip_title: 'Không hiển thị lại video này',
    page_title: 'Thống kê các khóa học của bạn',
    page_subtitle: 'Trạng thái của các khóa học bạn đã tạo',
    profile_add_info:
      'Thêm thông tin về <1>{{uncompletedText}}</1> để hoàn thiện hồ sơ của bạn.',
    profile_build:
      'Xây dựng hồ sơ cá nhân <1>tại đây</1>, chia sẻ cho chúng tôi biết các sở thích và kỹ năng của bạn.',
    profile_title: 'Cấp độ hoàn thiện hồ sơ',
    more_details: 'Thêm thông tin chi tiết'
  },

  errors: {
    answer: 'Vui lòng nhập câu trả lời',
    answer_correct: 'Chọn câu trả lời đúng',
    code: 'Vui lòng nhập mã của bạn',
    criterion: 'Vui lòng nhập tiêu chí',
    duration: 'Bạn bắt buộc phải nêu rõ thười lượng',
    element: 'Vui lòng nhập phần tử',
    email: 'Vui lòng nhập email của bạn',
    email_invalid: 'Email đã nhập không hợp lệ',
    feedback_correct: 'Vui lòng nhập phản hồi khi chọn đáp án chính xác',
    feedback_incorrect: 'Vui lòng nhập phản hồi khi chọn đáp án sai',
    host: 'Vui lòng nhập người chủ trì sự kiện',
    host_assessment: 'Vui lòng nhập ngời chủ trì bài đánh giá',
    image: 'Vui lòng tải lên một hình ảnh',
    location: 'Vui lòng nhập vị trí của bạn',
    live_location: 'Vui lòng chọn vị trí phát sóng',
    limit: 'Vui lòng nhập số phút phát trực tiếp',
    min_3char: 'Tối thiểu 3 ký tự',
    number: 'Vui lòng nhập số dương.',
    host_email_require: `Cần phải điền email của người chủ trì.`,
    attendee_email_require: `Cần phải điền email của người tham gia.`,
    name: 'Vui lòng nhậ tên của bạn',
    not_found_course: 'Không tìm thấy khóa học',
    not_found_event: 'Không tìm thấy sự kiện',
    not_found_assessment: 'Không tìm thấy bài đánh giá',
    password: 'Vui lòng nhập mật khẩu',
    password_digit: 'Ít nhất một chữ số',
    password_short: 'Mật khẩu quá ngắn, hãy nhập tối thiểu 10 ký tự',
    password_special: 'Ít nhất một ký tự đặc biệt',
    password_uppercase: 'Ít nhất một ký tự viết hoa',
    password_lowercase: 'Ít nhất một ký tự viết thường',
    phone: 'Vui lòng nhập điện thoại của bạn',
    phone_invalid: 'Số điện thoại không hợp lệ',
    position: 'Vui lòng nhập chức vụ của bạn',
    question: 'Vui lòng nhập câu hỏi',
    start_date: 'Bạn buộc phải chọn Ngày/Giờ bắt đầu',
    tag: 'Vui lòng chọn một thẻ',
    topics: 'Vui lòng chọn ít nhất một chủ đề',
    live_topics: 'Vui lòng thêm các chủ đề',
    title: 'Vui lòng nhập tiêu đề',
    title_assessment: 'Vui lòng nhập tiêu đề bài đánh giá',
    title_course: 'Vui lòng nhập tiêu đề khóa học',
    title_empty: 'Không thể để trống phần tiêu đề',
    title_event: 'Vui lòng nhập tiêu đề sự kiện',
    title_lesson: 'Vui lòng nhập tiêu đề bài học',
    title_quiz: 'Vui lòng nhập tên bài kiểm tra',
    username: 'Vui lòng nhập tên người dùng của bạn',
    upload_error: 'Lỗi - Tệp không tương thích!',
    upload_more_than_10: 'Bạn chỉ có thể tải lên tối đa 10 tệp cùng một lúc.',
    topics_max: 'Vui lòng thêm tối đa 3 chủ đề.',
    upload_excel: 'Hãy đảm bảo tệp bạn tải lên là chính xác.',
    title_excel: 'Lỗi khi tải file mẫu:',
    file_size_exceed: 'Kích thước tệp quá lớn',
    subtitle_excel:
      'Hãy đảm bảo bạn đã dùng đúng bản mẫu được cung cấp và điền chuẩn xác thông tin vào các cột.',
    select_broadcast_option: 'Hãy chọn một tùy chọn để phát sự kiện này',
    multi_hosts_number_error:
      'Số người thuyết trình không thể vượt quá mức quy định cho sự kiện này.',
    conference_people_number_error: `Số người tham gia không thể vượt quá mức quy định cho sự kiện này.`,
    select_max_host: 'Chọn ít nhất 1 người thuyết trình cho sự kiện.',
    select_max_conference: 'Chọn ít nhất 1 người tham dự sự kiện.',
    stream_stop_error: 'Video phát trực tiếp bị dừng đột ngột!',
    unsecure_context:
      'Lỗi nghiêm trọng: Trình duyệt không thể truy cập camera và micrô do bối cảnh không an toàn. Vui lòng cài đặt SSL và truy cập qua https',
    ws_not_supported:
      'Lỗi nghiêm trọng: WebSocket không được hỗ trợ trong trình duyệt này',
    no_org: 'Hãy chọn ít nhất 1 tổ chức để tiếp tục.',
    no_org_group: 'Hãy chọn ít nhất 1 nhóm tổ chức để tiếp tục.',
    waiting_to_join: 'Đang chờ ai đó tham gia!'
  },

  events: {
    title: 'Thêm thông tin về sự kiện trực tiếp',
    change_host: 'Đổi Người chủ trì',
    finished: 'Sự kiện đã kết thúc',
    countdown: 'Sự kiện trực tiếp sẽ lên sóng sau ',
    subtitle:
      'Đặt tên cho Sự kiện trực tiếp của bạn và cho khán giả biết họ sẽ học được gì từ nó.',
    poll_disabled: 'Sự kiện này không có bỏ phiếu thăm dò ý kiến.',
    disclaimer: `Tôi bảo đảm rằng sự kiện được ghi lại của tôi sẽ không:     - vi phạm quyền của bên thứ ba bất kỳ
    - chứa nội dung bất hợp pháp bất kỳ, bao gồm nội dung mang tính phỉ báng, tục tĩu, khiếm nhã, dâm ô, khiêu dâm, bạo lực, lạm dụng, lăng mạ, đe dọa hoặc phân biệt đối xử, kể cả nội dung đã được che bằng dấu hoa thị
    - mang tính công kích cá nhân đối với những người khác
    - chứa hành vi mạo danh người tham gia khác, giả dạng nhân vật của công chúng hoặc người nổi tiếng
    - chứa bản ghi hoặc thông tin cá nhân về một cá nhân bất kỳ mà không có sự đồng ý của cá nhân đó hoặc vi phạm các quy định bảo vệ dữ liệu ở bất kỳ nơi nào trên thế giới
    - chứa lời mời chào thương mại hoặc bất kỳ hình thức "spam" nào`,
    prompt_message:
      'Sự kiện sẽ kết thúc nếu bạn rời khỏi trang này. Bạn có chắc muốn rời khỏi trang này không?',
    duration_exceed_message:
      'Đã vượt quá thời lượng lên sóng, ứng dụng sẽ ngừng phát.',
    before_schedule_message:
      'Bạn sắp bắt đầu chương trình phát sóng trước thời gian dự kiến. Xin lưu ý rằng sự kiện sẽ kết thúc nếu bạn dừng phát sóng.',
    browser_unsupportive_message:
      'Trình duyệt của bạn không hỗ trợ chia sẻ màn hình. Bạn có thể xem trình duyệt nào được hỗ trợ tại liên kết này',
    cancel_switch_host_message:
      'Người chủ trì không có mặt. Sự kiện sẽ được tiếp tục từ đầu cầu của bạn.',
    coaching_prompt_message:
      'Trước khi sự kiện kết thúc, bạn không thể rời trang này.',
    event_modal_warn: 'Bạn có muốn rời khỏi sự kiện này không?',
    confirm_message: 'Sự kiện này sẽ kết thúc nếu bạn nhấp nút OK.',
    screen_share_denied: 'Bạn đã từ chối chia sẻ màn hình của mình',
    media_not_found:
      'Không tìm thấy Camera/Mic trên thiết bị của bạn, có thể do bạn chưa cấp quyền truy cập.',
    media_not_access:
      'Camera/Mic của bạn đang được dùng trong một quy trình khác không cho phép đọc thiết bị',
    constraint_error:
      'Không tìm thấy thiết bị nào phù hợp với các tiêu chí về video và âm thanh của bạn. Bạn có thể thay đổi các tiêu chí về video và âm thanh',
    media_access_denied: 'Bạn không được phép truy cập vào camera và micrô.'
  },

  filters: {
    days7: '7 ngày qua',
    days15: '15 ngày qua',
    days30: '30 ngày qua',
    days365: '365 ngày qua',
    date: 'Ngày tạo',
    relevance: 'Liên quan',
    popularity: 'Phổ biến',
    name: 'Tên',
    group: 'Nhóm',
    Newest_to_Oldest: 'Mới nhất đến Cũ nhất',
    Oldest_to_Newest: 'Cũ nhất đến Mới nhất',
    A_Z: 'Từ A đến Z',
    Z_A: 'Từ Z đến A'
  },

  helpers: {
    password:
      'Để đảm bảo tính bảo mật cho tài khoản của bạn, chúng tôi yêu cầu mật khẩu của bạn phải chứa ít nhất một chữ thường và chữ số. Mật khẩu cũng phải dài tối thiểu 10 ký tự.',
    phone:
      'Vui lòng điền cả mã quốc gia trong số điện thoại của bạn, ví dụ: +65',
    username:
      'Tên người dùng của bạn được coi là thông tin công khai và được chia sẻ với những người dùng khác khi cần. Do đó, chúng tôi khuyên bạn không nên dùng thông tin cá nhân để đặt tên người dùng.',
    public_description_normal:
      '<0><0/> </0> của bạn đã được lưu và được đặt ở trạng thái Riêng tư theo mặc định. Điều này nghĩa là chỉ bạn mới có thể xem nội dung này. Để công khai nội dung này, bạn có thể chọn một trong các tùy chọn bên dưới. Đăng tải khóa học của bạn ở chế độ Công khai có nghĩa là tất cả người dùng trong nền tảng đều có thể truy cập. Tùy chọn Người dùng cụ thể sẽ cho phép bạn chia sẻ khóa học của mình với những người dùng cụ thể bằng cách điền địa chỉ email được liên kết với tài khoản Sharelook của họ.',
    public_description_admin:
      '<0><0/></0> của bạn đã được lưu và được đặt ở trạng thái Riêng tư theo mặc định. Điều này nghĩa là chỉ bạn (và người tạo nội dung) mới có thể xem nội dung này. Để công khai nội dung này, bạn có thể chọn một trong các tùy chọn bên dưới. Đăng tải khóa học của bạn ở chế độ Công khai có nghĩa là tất cả người dùng trong nền tảng - bao gồm những người không thuộc tổ chức của bạn - đều có thể truy cập. Đăng tải ở chế độ Tổ chức có nghĩa là tất cả người dùng trong tổ chức được nêu sẽ có quyền xem. Bạn cũng có thể đăng ở chế độ công khai với 1 hoặc nhiều nhóm, nghĩa là chỉ những người dùng trong các nhóm đó mới có thể xem.  Cuối cùng, bạn có thể chọn đăng tải ở chế độ công khai với những người dùng cụ thể trong và ngoài tổ chức bằng cách điền địa chỉ email liên kết với tài khoản Sharelook của họ.'
  },

  labels: {
    add: 'Thêm',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Loại câu trả lời',
    answers: 'Câu trả lời',
    back_to_quiz: 'Quay lại danh sách Bài kiểm tra',
    back_to_question: 'Quay lại danh sách Câu hỏi',
    chat: 'Trò chuyện',
    chat_available: 'Sự kiện này không cho phép chat',
    chat_report: 'Báo cáo trò chuyện',
    choice_single: 'Chọn 1 đáp án',
    choice_multiple: 'Nhiều lựa chọn',
    choice_free: 'Lựa chọn "tự do"',
    choice_sorting: 'Lựa chọn "sắp xếp"',
    choice_matrix: 'Lựa chọn "Sắp xếp theo ma trận"',
    clone_lesson_permission: 'Quyền sao chép',
    code: 'Mã',
    correct: 'Chính xác',
    created: 'Ngày tạo',
    clone_modal: 'Sao chép Khóa học',
    cloning_course: 'Đang sao chép khóa học...',
    cloning: 'Đang sao chép...',
    cloning_course_desc:
      'Quá trình này sẽ mất chút thời gian. Xin hãy kiên nhẫn',
    cloning_success: 'Khóa học "<0/>" đã được sao chép thành công!',
    description: 'Mô tả',
    disclaimer: 'Tuyên bố khước từ trách nhiệm',
    drop_file: 'Thả tệp vào đây...',
    duration: 'Thời lượng',
    edit: 'Sửa',
    email: 'Email',
    event: 'Sự kiện',
    event_all: 'Tất cả sự kiện của người này',
    event_date: 'Ngày/giờ địa phương diễn ra sự kiện trực tiếp',
    event_this: 'Sự kiện này',
    expire: 'Hết hạn vào',
    expiry_date: 'Ngày hết hạn',
    forgot: 'Quên mật khẩu?',
    group: 'Nhóm',
    groups_list: 'Danh sách các nhóm',
    host: 'Chủ trì',
    id_annotation: 'ID chú thích',
    id_quiz: 'ID câu hỏi',
    incorrect: 'Sai',
    interests: 'Sở thích',
    invited: 'Đã mời',
    live_chat: 'Thảo luận trực tiếp',
    live_stream_limit: 'Số phút phát trực tiếp',
    contact_text:
      'Để thay đổi hạn mức phát trực tiếp hàng tháng của bạn, vui lòng liên hệ',
    contact_admin:
      '<0> Nếu bạn muốn thay đổi hạn mức phát trực tiếp hàng tháng của mình, vui lòng liên hệ </0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'Số phút phát trực tiếp còn lại: <0>{{ limit }}</0> phút <1/><2/> <3>Để thay đổi hạn mức phát trực tiếp hàng tháng của bạn, vui lòng liên hệ với </3> <4>admin@sharelook.com</4>',
    location: 'Vị trí',
    lessons: 'Bài học',
    location_broadcast: 'Vị trí máy chủ',
    location_broadcast_subtitle:
      'Thêm vị trí gần nhất với vị trí của máy chủ phát sóng để giảm độ trễ nghe nhìn',
    media_manager: 'Quản lý tệp tin',
    minutes: 'Phút',
    name: 'Tên',
    online_quiz: 'Bài kiểm tra trực tuyến',
    organiser: 'Tác giả',
    organization: 'Tổ chức',
    overall_emotion: 'Trải nghiệm tổng thể:',
    organizations_list: 'Danh sách các tổ chức',
    password: 'Mật khẩu',
    participants: 'Người tham gia',
    picture: 'Ảnh (16:9)',
    phone: 'Điện thoại',
    photo: 'Ảnh',
    poll: 'Thăm dò ý kiến',
    position: 'Chức vụ',
    processing: 'Đang xử lý',
    privacy_settings: 'Thiết lập riêng tư',
    question: 'Câu hỏi',
    quiz_create: 'Tạo bài kiểm tra mới',
    quiz_name: 'Tên bài kiểm tra',
    quiz_update: 'Cập nhật bài kiểm tra',
    select_organization: 'Chọn một tổ chức',
    settings: 'Cài đặt',
    show: 'Hiện',
    show_graph: 'Hiển thị biểu đồ kết quả',
    signin: 'Đăng nhập',
    signup: 'Đăng ký',
    sort_by: 'Sắp xếp theo',
    start_date: 'Ngày bắt đầu',
    tags: 'Thẻ',
    terms: 'Tôi đồng ý với các <1>điều khoản và điều kiện</1> này.',
    title: 'Tiêu đề',
    topics: 'Chủ đề',
    topic: 'Chủ đề',
    total_comments: 'Tổng số bình luận',
    username: 'Tên người dùng',
    users_list: 'Danh sách người dùng',
    users_emails: 'Điền email từng người dùng cụ thể',
    description_specifiction_email:
      'Vui lòng nhập 1 địa chỉ email trên mỗi dòng để chia sẻ nội dung này với nhiều người dùng đích danh.',
    message_specific_email: 'Vui lòng nhập email của người dùng cụ thể.',
    viewers: 'Người xem',
    edit_course: 'Sửa',
    edit_assessment: 'Sửa',
    edit_event: 'Sửa',
    delete_course: 'Xóa',
    delete_event: 'Xóa',
    delete_assessment: 'Xóa',
    view_course: 'Lượt xem',
    view_event: 'Lượt xem',
    view_assessment: 'Lượt xem',
    date_event: 'Ngày diễn ra sự kiện trực tiếp',
    date_assessment: 'Ngày diễn ra bài đánh giá trực tiếp',
    clone_of: 'Sao chép',
    clone_course:
      'Tạo bản sao của khóa học này, bạn có thể chỉnh sửa độc lập bản sao mà không ảnh hưởng tới bản gốc, bao gồm mọi bài học và trang của khóa học.',
    make: 'Để',
    available_to: 'công khai với mọi người dùng ShareLook',
    uploaded_by: 'Được tải lên bởi: ',
    course: 'Khóa học',
    assessment: 'Bài đánh giá',
    user_not_exist:
      'Người dùng này không tồn tại, bạn có muốn gửi lời mời cho họ không?',
    check_user: 'Thông báo',
    user_not_exist_in_org:
      'Người dùng này không có mặt trong tổ chức, bạn có muốn gửi lời mời cho họ không?',
    title_modal_stream: 'Thay đổi giới hạn phát trực tiếp của tổ chức',
    des_warning_stream: 'Bạn sắp thay đổi',
    monthly_stream: 'giới hạn phát trực tiếp hàng tháng:',
    min_per_month: 'phút/tháng',
    broadcast_label: 'Tôi muốn làm:',
    hosts_emails: `Điền email cụ thể của người chủ trì`,
    attendee_emails: `Điền email cụ thể của người tham gia`,
    description_host_specifiction_email:
      'Vui lòng nhập 1 địa chỉ email trên mỗi dòng.',
    presenter_label: 'Người thuyết trình',
    presenter_label_conference: 'Số người',
    event_privacy: 'Chế độ hội nghị'
  },

  broadcastOptions: {
    stream_from_phone: 'Phát sóng trực tiếp qua điện thoại',
    other_webrtc: 'Hội thảo online qua máy tính',
    multihost: 'Hội thảo online Multicast qua máy tính',
    peer2peer: 'Buổi huấn luyện',
    conference: 'Hội nghị trực tiếp'
  },

  lessoncreate: {
    title: 'Thêm thông tin về bài học',
    subtitle:
      'Đặt tên cho bài học của bạn và cho khán giả biết họ sẽ học được gì từ nó.',
    input_label_title: 'Tên bài học',
    input_label_topics: 'Chủ đề bài học',
    input_label_description: 'Mô tả bài học',
    delete_warning: 'Bạn có chắc muốn xóa trang này không?'
  },

  lessonoverview: {
    title: 'Thêm bài học',
    subtitle: 'Thêm bài học hiện có hoặc tạo một bài học mới',
    new_lesson: 'tạo một bài học mới',
    new_lesson_sub: 'Tạo một bài học mới hoàn toàn!',
    existing_lesson: 'Chọn bài học hiện có',
    existing_lesson_sub:
      'Liên kết với bài học hiện có, thay đổi trong bài học này cũng sẽ tác động tới bài học có liên quan trong các khóa học khác.',
    clone_lesson: 'sao chép bài học hiện có',
    clone_lesson_sub:
      'Tạo một bản sao độc lập của bài học trong khóa học này, những thay đổi trong bài học này sẽ không ảnh hưởng đến bài học gốc.',
    clone_lesson_modal_sub:
      'Vui lòng nhấn vào nút sao chép bên dưới bài học bạn muốn thêm vào khóa học của mình.'
  },

  management: {
    groups_title: 'Quản lý nhóm',
    delete_warning: 'Bạn chắc chứ?',
    organizations_title: 'Tổ chức của tôi',
    organizations_subtitle: 'Thêm tổ chức vào danh sách của bạn',
    users_title: 'Quản lý người dùng',
    users_position: 'Quản lý tài khoản cấp cao',
    user_not_found: 'Không tìm thấy người dùng',
    select_org: 'Hãy tìm và chọn một tổ chức để quản lý người dùng'
  },

  audio: {
    modal_title: 'Chèn âm thanh',
    list_view: 'Chế độ xem danh sách',
    create_audio_modal_title: 'Tạo âm thanh',
    edit_audio_modal_title: 'Chỉnh sửa âm thanh',
    public_audio_not_found: 'Không tìm thấy tệp âm thanh.',
    private_audio_not_found: 'Bạn chưa tải lên bất kỳ tệp âm thanh nào',
    are_you_sure_to_delete: 'Bạn có chắc muốn xóa không?',
    type_something: 'Viết gì đó',
    select_voice: 'Chọn',
    file_name: 'Tên tệp',
    description: 'Mô tả',
    topic: 'Chủ đề',
    key_words_tag: 'Từ khóa Tag',
    mp3_audio: 'Tệp âm thanh MP3',
    created: 'Đã tạo',
    duration: 'Thời lượng',
    close: 'đóng'
  },

  image: {
    modal_title: 'Chèn hình ảnh',
    image: 'Ảnh',
    pixel: 'Pixel',
    dimension: 'Kích thước',
    public_image_not_found: 'Không tìm thấy hình ảnh.',
    private_image_not_found: 'Bạn chưa tải lên bất kỳ hình ảnh nào'
  },

  annotation: {
    modal_title: 'Chú thích'
  },

  text: {
    modal_title: 'Soạn thảo văn bản'
  },

  video: {
    modal_title: 'Chèn Video',
    image: 'Video',
    mp4_video: 'Video MP4',
    public_video_not_found: 'Không tìm thấy video.',
    private_video_not_found: 'Bạn chưa tải lên bất kỳ video nào'
  },

  media: {
    title: 'Thư viện tệp tin',
    subtitle: 'Thư viện tệp tin của bạn',
    modal_title: 'Tải tệp tin lên',
    delete_warning: 'Xác nhận xóa',
    delete_message:
      'Tệp tin đã xóa sẽ vẫn xuất hiện tại các trang mà chúng đã được sử dụng',
    dropzone_text: 'hoặc Kéo và Thả',
    delete_success: 'Đã xóa tệp tin thành công',
    upload_file: 'Tải tệp lên',
    drag_drop: 'hoặc Kéo và Thả',
    import_file: 'Nhập (các) tệp từ máy tính của bạn',
    no_media: 'Bạn chưa tải lên bất kỳ tệp tin nào',
    media_type: 'Loại tệp tin',
    video: 'Video',
    image: 'Ảnh',
    audio: 'Âm thanh',
    gif: 'Ảnh động gif',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Không tìm thấy tệp tin.',
    of: 'Của',
    disclaimer: `Tôi bảo đảm rằng tệp tin của tôi sẽ không:     - vi phạm quyền của bên thứ ba bất kỳ
    - chứa nội dung bất hợp pháp bất kỳ, bao gồm nội dung mang tính phỉ báng, tục tĩu, khiếm nhã, dâm ô, khiêu dâm, bạo lực, lạm dụng, lăng mạ, đe dọa hoặc phân biệt đối xử, kể cả nội dung đã được che bằng dấu hoa thị
    - mang tính công kích cá nhân đối với những người khác
    - chứa hành vi mạo danh người tham gia khác, giả dạng nhân vật của công chúng hoặc người nổi tiếng
    - chứa thông tin cá nhân về một đối tượng bất kỳ mà không có sự đồng ý của cá nhân đó hoặc vi phạm các quy định bảo vệ dữ liệu ở bất kỳ nơi nào trên thế giới
    - chứa lời mời chào thương mại hoặc bất kỳ hình thức "spam" nào`,
    my_media: 'Thư viện của tôi',
    public_library: 'Thư viện công cộng',
    organization_library: 'Thư viện của tổ chức',
    upload_from_computer: 'Tải lên từ Máy tính',
    create: 'Tạo',
    all: 'Tất cả',
    male: 'Nam',
    female: 'Nữ',
    processing_audio: 'Đang xử lý âm thanh',
    create_annotation: 'Tạo chú thích',
    popup_over_lesson_text:
      'Chú thích sẽ hiện ra trên trang bài học sau khi người dùng nhấp vào',
    edit_detail: 'Chỉnh sửa chi tiết',
    delete: 'Xóa',
    go_create_audio: 'Tạo âm thanh',
    show_more_details: 'Hiện thêm thông tin',
    show_less_details: 'Hiện ít thông tin hơn',
    drop_files: 'Thả file và chọn nơi tải lên',
    or: 'Hoặc',
    import_files: 'Lấy file từ máy tính'
  },

  navigation: {
    account: 'Tài khoản',
    assessments: 'Bài đánh giá',
    dashboard: 'Bảng điều khiển',
    groups: 'Quản lý nhóm',
    logout: 'Đăng xuất',
    organisations: 'Tổ chức',
    organizations_users: 'Tổ chức & Người dùng',
    reports: 'Báo cáo',
    schedule: 'Lịch trình',
    training: 'Đào tạo',
    users: 'Người dùng',
    workshop: 'Hội thảo của tôi',
    nowLive: 'Phát sóng'
  },

  onboarding: {
    step1_title: 'Bước 1: Giới thiệu đôi chút về bản thân bạn',
    step1_subtitle:
      'Tên bạn là gì? Bạn đến từ đâu? Chức danh công việc của bạn là gì?',
    step2_title: 'Bước 2: Chọn một số kỹ năng bạn muốn cải thiện',
    step2_subtitle:
      'Tiếp theo, hãy cho biết bạn muốn hiểu rõ hơn về điều gì. Có điều gì bạn chưa hiểu rõ không? Một lĩnh vực nghiên cứu mới? Người thân của bạn làm gì? '
  },

  pagebuilder: {
    title: 'Tạo bài học',
    subtitle:
      'Đã đến lúc tạo nội dung để truyền tải tri thức cho người xem, bạn có thể dùng hình ảnh, video và ảnh đồ họa thông tin',
    select_layout: 'Chọn một bố cục trang',
    template1: 'Trống',
    template2: 'Tiêu đề & Phụ đề',
    template3: 'Tiêu đề & Văn bản',
    template4: 'Tiêu đề, Tệp tin & Văn bản',
    template5: 'Tiêu đề & Tệp tin',
    template6: 'Tiêu đề & Bài kiểm tra'
  },

  pageconstructor: {
    title: 'Tạo và sao chép bài học',
    subtitle:
      'Đã đến lúc tạo nội dung để truyền tải tri thức cho người xem, bạn có thể thêm hình ảnh, video và ảnh đồ họa thông tin'
  },

  passwordreset: {
    success_coded:
      'Chúng tôi đã gửi mã xác nhận đến địa chỉ email bạn đã cung cấp, vui lòng sao chép mã này vào ô bên dưới để đặt mật khẩu mới.',
    success_changed:
      'Bạn đã đặt mật khẩu mới thành công. Bạn có thể đăng nhập ngay bây giờ.'
  },

  placeholders: {
    search: 'Tìm kiếm',
    answer: 'Câu trả lời',
    chat: 'Viết gì đó...',
    code: 'Mã',
    criterion: 'Tiêu chí',
    date_event: 'Chọn ngày và giờ',
    date_start: 'Ngày bắt đầu',
    date_expire: 'Ngày hết hạn',
    description: 'Mô tả',
    elements: 'Sắp xếp các phần tử',
    email: 'Email',
    feedback_correct: 'Phản hồi khi trả lời đúng',
    feedback_incorrect: 'Phản hồi khi trả lời sai',
    host: 'Chủ trì',
    keywords: '(Các) từ khóa tìm kiếm',
    lesson_description: 'Mô tả bài học',
    location: 'Vị trí',
    minutes: 'Phút',
    name: 'Tên',
    organiser: 'Tác giả',
    organization: 'Tổ chức',
    password: 'Mật khẩu',
    phone: 'Điện thoại',
    photo: 'Ảnh',
    picture: 'Hình ảnh',
    point: 'Điểm',
    position: 'Chức vụ',
    question: 'Câu hỏi',
    quiz: 'Tên bài kiểm tra',
    search_course: 'Tìm kiếm theo khóa học',
    search_media: 'Tìm tệp tin',
    search_name: 'Tìm kiếm theo tên',
    search_title: 'Tìm kiếm theo tiêu đề',
    search_training: 'Tìm khóa Đào tạo',
    settings: 'Cài đặt',
    tags: 'Thẻ',
    title: 'Tiêu đề',
    topics: 'Chủ đề',
    username: 'Tên người dùng',
    keyword: 'Từ khóa',
    max_500_characters: 'Tối đa 500 ký tự ',
    no_description: 'Tệp này không có thông tin mô tả',
    no_keyword: 'Tệp này không có từ khóa nào',
    no_topics: 'Tệp này không có chủ đề',
    feedback: 'Tin nhắn',
    contact: 'Chúng tôi có thể giúp gì cho bạn?'
  },

  publishsettings: {
    title: 'Cài đặt Đăng tải',
    event_subtitle:
      'Thêm các thiết lập cho sự kiện của bạn, đối tượng nào có thể xem và tương tác với sự kiện này',
    assessment_subtitile:
      'Đặt tên cho Bài đánh giá của bạn và cho biết người xem sẽ học được gì từ nó.',
    course_subtitle:
      'Thêm các thiết lập cho sự kiện của bạn, đối tượng nào có thể xem và tương tác với sự kiện này',
    disclaimer: `1.	Đăng ký

  Khi thực hiện hành động đăng ký trở thành người dùng/tạo tài khoản, bạn đồng ý với [Thỏa thuận người dùng] và xác nhận đã đọc [Chính sách bảo mật] của chúng tôi



  2.	Tạo khóa học

  Khi sử dụng các công cụ của chúng tôi và tạo nội dung khóa học, bạn đồng ý với [Thỏa thuận người dùng] và xác nhận đã đọc [Chính sách bảo mật] của chúng tôi



  3.	Tạo sự kiện

  Khi sử dụng các công cụ của chúng tôi và tạo sự kiện, bạn đồng ý với [Thỏa thuận người dùng] và xác nhận đã đọc [Chính sách bảo mật] của chúng tôi


  4.	Tạo bài đánh giá

  Khi sử dụng các công cụ của chúng tôi và tạo bài dánh giá, bạn đồng ý với [Thỏa thuận người dùng] và xác nhận đã đọc [Chính sách bảo mật] của chúng tôi`,
    dates_validation_error: 'Bạn cần điền đủ cả hai ngày.',
    course_dates_validation_error: 'Vui lòng nhập ngày bắt đầu và ngày hết hạn cho khóa học này.',
    emails_validation_error: 'Danh sách email không hợp lệ.',
    specific_email_validation_error: 'Chỉ được điền 1 email.',
    i_agree_to_these: 'Tôi đồng ý với ',
    terms_and_conditions: 'các Điều khoản và Điều kiện này.',
    PublicDescription:
      'Người dùng độc lập miễn phí: (tùy chọn riêng tư và công khai) [Khóa học | Sự kiện | Bài đánh giá] của bạn đã được lưu và đặt ở chế độ Riêng tư theo mặc định. Điều này nghĩa là chỉ bạn mới có thể xem nội dung này. Để đăng tải nội dung này, bạn có thể chọn chế độ công khai ở bên dưới. Điều này nghĩa là tất cả người dùng trong nền tảng đều có thể truy cập khóa học này.',
    OrganisationsDescription:
      'Người dùng trong tổ chức: (Thay vì ""Hoàn thành"", hãy chọn ""Đăng tải"" và đưa nội dung này ra trang công khai giống như những người dùng khác mà không chọn bất cứ tùy chọn công khai nào.) [Khóa học | Sự kiện | Bài đánh giá] của bạn đã được lưu và đặt ở chế độ Riêng tư theo mặc định. Điều này có là chỉ bạn và Quản trị viên trong tổ chức của bạn mới có thể xem được. Với tư cách là người dùng, bạn không thể tự đăng tải nội dung trong tổ chức vì điều này cần đến quyền của quản trị viên. Vui lòng liên hệ với một trong những Quản trị viên của bạn và yêu cầu người này đăng tải nội dung của bạn công khai với toàn bộ tổ chức, với các nhóm cụ thể trong tổ chức của bạn hoặc cho những người dùng cụ thể.',
    OrganisationGroupsDescription:
      'Quản trị viên của Tổ chức: (Đối với nội dung được tạo trong tổ chức: Riêng tư, công khai, tổ chức, nhóm, người dùng cụ thể): [Khóa học | Sự kiện | Bài đánh giá] của bạn đã được lưu và đặt ở chế độ Riêng tư theo mặc định. Điều này nghĩa là chỉ bạn (và người tạo nội dung) mới có thể xem nội dung này. Để công khai nội dung này, bạn có thể chọn một trong các tùy chọn bên dưới. Đăng tải khóa học của bạn ở chế độ Công khai có nghĩa là tất cả người dùng trong nền tảng - bao gồm những người không thuộc tổ chức của bạn - đều có thể truy cập. Đăng tải ở chế độ Tổ chức có nghĩa là tất cả người dùng trong tổ chức được nêu sẽ có quyền xem. Bạn cũng có thể đăng ở chế độ công khai với 1 hoặc nhiều nhóm, nghĩa là chỉ những người dùng trong các nhóm đó mới có thể xem.  Cuối cùng, bạn có thể chọn đăng tải ở chế độ công khai với những người dùng cụ thể trong và ngoài tổ chức bằng cách điền địa chỉ email liên kết với tài khoản Sharelook của họ.',
    SpecificUsersDescription:
      'Người dùng độc lập có trả phí: (chế độ riêng tư, công khai và người dùng cụ thể) [Khóa học | Sự kiện | Bài đánh giá] của bạn đã được lưu và đặt ở chế độ Riêng tư theo mặc định. Điều này nghĩa là chỉ bạn mới có thể xem nội dung này. Để công khai nội dung này, bạn có thể chọn một trong các tùy chọn bên dưới. Đăng tải khóa học của bạn ở chế độ Công khai có nghĩa là tất cả người dùng trong nền tảng đều có thể truy cập. Tùy chọn Người dùng cụ thể sẽ cho phép bạn chia sẻ khóa học của mình với những người dùng cụ thể bằng cách điền địa chỉ email được liên kết với tài khoản Sharelook của họ.'
  },

  quiz: {
    quiz_empty: 'Bạn chưa tạo bài kiểm tra nào',
    questions_empty: 'Bạn vẫn chưa tạo câu hỏi nào'
  },

  regions: {
    asia_pacific_australia: 'Australia',
    asia_pacific_india: 'Ấn Độ',
    asia_pacific_japan: 'Nhật Bản',
    asia_pacific_s_korea: 'Hàn Quốc',
    asia_pacific_singapore: 'Singapore',
    asia_pacific_taiwan: 'Đài Loan',
    eu_belgium: 'Bỉ',
    eu_germany: 'Đức',
    eu_ireland: 'Ireland',
    south_america_brazil: 'Brazil',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'Nam Carolina',
    us_east_virginia: 'Virginia',
    us_west_california: 'California',
    us_west_oregon: 'Oregon'
  },

  reports: {
    title: 'Báo cáo',
    workshop_report: 'Báo cáo hội thảo',
    user_report: 'Báo cáo người dùng',
    organization_workshop: 'Tổ chức hội thảo',
    course: 'Khóa học',
    live_event: 'Sự kiện trực tiếp',
    workShop_graph: 'Biểu đồ hội thảo',
    organization_account: 'Tài khoản tổ chức',
    all: 'Tất cả',
    name: 'Tên',
    id_number: 'Số ID',
    email: 'Email',
    search_user_report: 'Tìm Báo cáo Người dùng',
    participant: 'Người tham gia',
    participants: 'Người tham gia',
    host: 'Chủ trì',
    username: 'Tên người dùng',
    event: 'Sự kiện',
    quiz: 'Bài kiểm tra',
    assessment: 'Bài đánh giá',
    time: 'Thời gian',
    no_recent_activity: 'Không có hoạt động gần đây',
    workshops: 'Hội thảo',
    courses: 'Các khóa học',
    live_events: 'Sự kiện trực tiếp',
    live_assessments: 'Đánh giá trực tiếp',
    quizzes: 'Câu hỏi',
    overview: 'Tổng quan',
    by: 'bởi',
    views: 'Lượt xem',
    status: 'Trạng thái',
    poll: 'Thăm dò ý kiến',
    comment: 'Bình luận',
    comments: 'Bình luận',
    no_comments: 'Không có bình luận',
    no_polls: 'Không có cuộc thăm dò',
    live_date: 'Ngày trực tiếp',
    score: 'Điểm',
    question: 'Câu hỏi',
    submit: 'Gửi',
    recent_activity: 'Hoạt động gần đây',
    ago: 'trước đó',
    no_data_found: 'Không tìm thấy dữ liệu',
    start_end_live: 'Bắt đầu/Kết thúc trực tiếp',
    join_leave_date: 'Tham gia / Rời khỏi',
    watched_time: 'Thời gian đã xem',
    complete: 'Hoàn thành',
    in_complete: 'Chưa hoàn thành',
    today: 'Hôm nay',
    seven_days: '7 ngày',
    last_month: 'Tháng trước',
    one_year: '1 năm',
    all_time: 'Toàn bộ thời gian',
    report: 'Báo cáo',
    from_date: 'Từ ngày',
    to_date: 'Đến ngày',
    all_workshop: 'Tất cả Hội thảo',
    all_participants: 'Tất cả Người tham gia',
    live_assessment: 'Đánh giá trực tiếp',
    users: 'Người dùng',
    download: 'Tải về',
    recent: 'Gần đây',
    WorkShop: 'Hội thảo',
    Activity: 'Hoạt động',
    created_date: 'Ngày tạo',
    lessons: 'Bài học',
    lesson: 'Bài học',
    completed: 'Đã hoàn thành',
    report_download: 'Tải báo cáo',
    this_month: 'Tháng này',
    search_course: 'Tìm kiếm khóa học',
    participants_graph: 'Biểu đồ người tham gia',
    viewed: 'Đã xem',
    enrolled: 'Đã ghi danh',
    description: 'Mô tả',
    topic: 'Chủ đề',
    analytic: 'Phân tích',
    quiz_list: 'Danh sách câu hỏi',
    select_one: 'Chọn một',
    group_status: 'Trạng thái nhóm',
    duration_min: 'Thời lượng (phút)',
    submit_poll: 'Gửi phiếu bầu',
    download_events: 'Tải sự kiện',
    search_event: 'Tìm kiếm sự kiện',
    duration: 'Thời lượng',
    total_participants: 'Tổng số người tham gia',
    message: 'Tin nhắn',
    avg_message: 'Trung bình Tin nhắn',
    per_message: 'PHẦN TRĂM TIN NHẮN/SỰ KIỆN'
  },

  signup: {
    success_step1:
      'Chúng tôi đã gửi mã xác nhận đến địa chỉ email bạn đã cung cấp, vui lòng sao chép mã này vào ô bên dưới để xác nhận đăng ký.',
    success_step2: 'Xin cảm ơn. Bạn đã đăng ký thành công.',
    privacy: `Tôi đồng ý với <1>Điều khoản & Điều kiện</1> và <3>Chính sách bảo mật</3> của Sharelook`
  },

  stream: {
    emotion_impressive: 'Ấn tượng',
    emotion_unimpressive: 'Không mấy ấn tượng',
    message_not_started: 'Sắp ra mắt',
    message_running: 'Trực tiếp',
    message_processing:
      'Chúng tôi đang xử lý bản ghi trực tiếp để phát lại. Vui lòng quay lại sau để xem video cũng như thêm đánh giá và phản hồi'
  },

  tabs: {
    audience: 'Khán giả',
    course: 'Tổng quan về khóa học',
    details: 'Thông tin về sự kiện trực tiếp',
    description: 'Mô tả',
    host: 'Chủ trì',
    lesson: 'Tổng quan về bài học',
    lessons: 'Bài học',
    overview: 'Tổng quan',
    page: 'Trình tạo trang',
    publish: 'Đăng tải',
    settings: 'Cài đặt Đăng tải',
    total_views: 'Tổng số lượt xem',
    live_participates: 'Người tham gia trực tiếp',
    live_chats: 'Trò chuyện trực tiếp',
    live_quiz: 'Cuộc thăm dò trực tiếp',
    trainer_rating: 'Đánh giá giảng viên',
    trainer_times: 'Giảng viên',
    courses_quizzes: 'Các câu hỏi trong khóa học',
    user_list: 'Danh sách người dùng',
    discussion: 'Thảo luận',
    notes: 'Ghi chú của tôi'
  },

  topics: {
    SALES_TRAINING: 'Đào tạo kỹ năng bán hàng',
    NEGOTIATION_TRAINING: 'Đào tạo kỹ năng đàm phán',
    CROSS_CULTURAL_AWARENESS: 'Nhận thức đa văn hóa',
    NETWORKING_SKILLS: 'Kỹ năng tạo lập mạng lưới',
    SOFTWARE_ARCHITECTURE: 'Kiến trúc phần mềm',
    PROJECT_MANAGEMENT: 'Quản lý dự án',
    DIGITAL_TRANSFORMATION: 'Chuyển đổi kỹ thuật số',
    IT_CONSULTING: 'Tư vấn CNTT',
    MANAGEMENT_CONSULTING: 'Tư vấn quản lý',
    HR_CONSULTING: 'Tư vấn nhân sự',
    INTERNET_OF_THINGS: 'Internet vạn vật (IoT)',
    CYBERSECURITY: 'An ninh mạng',
    PRIVACY_AND_GDRP: 'Bảo mật và GDPR'
  },

  training: {
    title: 'Đào tạo',
    title_assessment: 'Bài đánh giá',
    subtitle: 'Các khóa học và sự kiện trực tiếp',
    enrolled_title: 'Các khóa học và sự kiện trực tiếp đã ghi danh',
    enrolled_subtitle: 'Các khóa học và sự kiện trực tiếp bạn đã đăng ký',
    enrolled_message: 'Bạn hiện chưa đăng ký khóa học hay sự kiện nào.',
    past_live_event_title: 'Sự kiện trực tiếp từng diễn ra',
    past_live_event_subTitle: 'Sự kiện trực tiếp từng diễn ra',
    past_live_event: 'Không có sự kiện trực tiếp nào từng diễn ra',
    recomended_title: 'Các khóa học và sự kiện trực tiếp được đề xuất cho bạn',
    now_live_event_title: 'Đang phát trực tiếp',
    now_live_event_subTitle: 'Các sự kiện đang trực tiếp hoặc sắp diễn ra',
    now_live_event: 'Hiện không có sự kiện trực tiếp nào diễn ra.',
    webinar_event_title: 'Kênh hội thảo online',
    webinar_event_subTitle: 'Hội thảo online từng diễn ra',
    webinar_event: 'Hiện không có buổi hội thảo online nào.',
    p2p_event_title: 'Buổi huấn luyện',
    p2p_event_subTitle: 'Buổi huấn luyện từng diễn ra',
    p2p_event: 'Hiện không có buổi huấn luyện nào.',

    now_live_assessment_title: 'Đang phát trực tiếp',
    now_live_assessment_subTitle:
      'Bài đánh giá trực tiếp đang hoặc sáp diễn ra',
    now_live_assessment_message:
      'Hiện không có buổi đánh giá trực tiếp nào diễn ra.',

    upcoming_assessment_title: 'Bài đánh giá trực tiếp sắp diễn ra',
    upcoming_assessment_subtitle: 'Bài đánh giá trực tiếp sắp diễn ra',
    upcoming_assessment_message:
      'Hiện không có buổi đánh giá trực tiếp nào sắp diễn ra.',

    past_live_assessment_title: 'Các bài đánh giá trực tiếp từng diễn ra',
    past_live_assessment_subTitle: 'Các bài đánh giá trực tiếp từng diễn ra',
    past_live_assessment_message:
      'Hiện không có bài đánh giá trực tiếp từng diễn ra.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Chúng tôi có các khóa học và sự kiện trực tiếp được biên tập dựa trên <0><0/></0> của bạn',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Tìm khóa Đào tạo',
    search_assessment: 'Tìm Bài đánh giá',
    recomended_message:
      'Hiện tại không có khóa học và sự kiện nào được đề xuất cho bạn.'
  },

  warnings: {
    delete: 'Bạn chắc chứ?'
  },

  workshop: {
    title: 'Hội thảo của tôi',
    subtitle: 'Tạo khóa học hoặc tổ chức sự kiện trực tiếp của riêng bạn',
    new_course: 'Tạo một khóa học mới',
    new_event: 'Tạo một sự kiện trực tiếp mới',
    new_assessment: 'Tạo một bài đánh giá trực tiếp mới',
    courses_title: 'Các khóa học và sự kiện trực tiếp đã tạo',
    courses_subtitle:
      'Chỉnh sửa & Đăng tải khóa học bạn đã tạo và lập kế hoạch cho các sự kiện trực tiếp',
    tags_course: 'Khóa học',
    tags_live: 'Sự kiện trực tiếp',
    tags_assessment: 'Bài đánh giá trực tiếp'
  },

  help_center: {
    sidebar: {
      title: 'Chúng tôi có thể giúp gì cho bạn?',
      back_to: 'Bảng điều khiển'
    },
    menu: {
      help_center: 'Trung tâm trợ giúp',
      whats_new: 'Có gì mới',
      feedback: 'Phản hồi',
      feedback_title: 'Gửi phản hồi cho Sharelook',
      terms_and_conditions: 'Điều khoản và Điều kiện',
      privacy_policy: 'Chính sách bảo mật',
      contact_us: 'Liên hệ với chúng tôi'
    },
    get_started: {
      title: 'Bắt đầu cùng Sharelook',
      description: {
        main:
          'CHÚNG TÔI TÍCH HỢP VIDEO TRỰC TIẾP VÀO CÔNG CỤ XÂY DỰNG KHÓA HỌC RẤT DỄ DÙNG',
        tagline:
          'Với hệ thống phát sóng trực tiếp được cấp bằng sáng chế của ShareLook, bạn có thể tạo tương tác, tự động hóa việc học và tối đa hóa việc chia sẻ kiến ​​thức.'
      }
    },
    whats_new: {
      title: 'Bắt đầu cùng Sharelook',
      description: {
        main:
          'Bạn có biết rằng bài học theo phong cách Kể chuyện có thể được tạo trong thời gian ngắn và không quá tốn kém không?  Bạn nên kết hợp công cụ xây dựng khóa học ShareLook với các tài năng phù hợp. Bạn có thể hỏi chúng tôi "CÁCH THỰC HIỆN',
        tagline: ''
      }
    },
    create_workshop: 'Cách tạo hội thảo',
    create_course: 'Cách tạo khóa học',
    create_user: 'Cách tạo người dùng',
    create_group: 'Cách tạo nhóm',
    create_webinar: 'Cách tạo hội thảo online',
    create_live_event: 'Cách tạo sự kiện trực tiếp',
    create_live_assessment: 'Cách tạo bài đánh giá trực tiếp',
    create_live_on_mobile: 'Tạo buổi phát trực tiếp trên Di động',
    personalize_profile: 'Cá nhân hóa cho Hồ sơ',
    manage_group: 'Quản lý nhóm',
    report: 'Báo cáo',
    add_annotations: 'Cách thêm chú thích/cửa sổ thông báo',
    add_audio: 'Cách thêm tệp âm thanh',
    add_header_and_footer: 'Thêm Đầu trang & Chân trang',
    add_image: 'Cách thêm hình ảnh',
    add_quiz_content: 'Cách thêm nội dung bài kiểm tra',
    add_text_content: 'Cách thêm nội dung văn bản',
    add_user: 'Cách thêm người dùng',
    add_video: 'Cách thêm video',
    clone_course: 'Cách sao chép khóa học',
    find_live_broadcast: 'Cách tìm chương trình phát sóng trực tiếp',
    contact_us: {
      title: 'Liên hệ với chúng tôi',
      subject_placeholder: 'Nhập chủ đề*',
      content_placeholder: 'Nhập tin nhắn*',
      subject_required: '*Chủ đề là thông tin bắt buộc phải nhập',
      content_required: '*Tin nhắn là thông tin bắt buộc phải nhập',
      submit: 'Gửi',
      cancel: 'Hủy',
      sent: 'Đã gửi'
    },
    feedback: {
      title: 'Gửi phản hồi cho Sharelook',
      attach_title: 'Đính kèm tệp',
      choose: 'Chọn tệp',
      detail: 'Tệp này sẽ được chia sẻ với đội ngũ hỗ trợ',
      content_placeholder: 'Nhập tin nhắn*',
      content_required: '*Tin nhắn là thông tin bắt buộc phải nhập',
      submit: 'Gửi',
      cancel: 'Hủy',
      sent: 'Đã gửi'
    }
  },
  discussion: {
    join_discussion: 'Tham gia thảo luận'
  },
  notes: {
    title: 'Ghi chú của tôi',
    add_note: 'Thêm ghi chú mới'
  }
}
